<div *ngIf="reports">
  <app-physical-report
    [reportID]="reportID"
    [typeReport]="typeReport"
    [poReport]="poReport"
    [destructionclientsname]="destructionclientsname"
    (out)="closeReport($event)"
  ></app-physical-report>
</div>
<div *ngIf="!reports">
  <div class="modal-header" style="text-align: center">
    <button
      type="button"
      (click)="closeModal()"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div
    *ngIf="guardando || cargando"
    style="text-align: center"
    class="modal-body"
  >
    <app-loading *ngIf="cargando"></app-loading>
    <div *ngIf="guardando">
      <h2>
        <b><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i> Saving...</b>
      </h2>
    </div>
  </div>
  <div *ngIf="notfound">
    <div style="margin-top: 200px">
      <div class="col-sm-12">
        <div class="text-center error-box">
          <h2 class="font-xl">
            <strong>
              <i class="fa fa-fw fa-warning fa-lg text-warning"></i> PI
              <u>not</u> found
            </strong>
          </h2>
          <br />
          <p class="lead">
            We are sorry but in our database we do not have any records that
            match your search.
          </p>
          <!-- <p class="font-md"><b>......Try another query in the search engine</b></p><br> -->
        </div>
      </div>
    </div>
    <div>
      <div style="text-align: center; margin: 50px">
        <button
          type="button"
          class="btn btn-danger btn-md noticket"
          (click)="end()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!guardando && !cargando && !notfound">
    <div class="modal-body pi">
      <!-- <form #f="ngForm"> -->
      <div *ngIf="action != 'delete'">
        <!-- --------------------------------------Seccion 0------------------------------------------ -->

        <div>
          <div class="" *ngIf="action == 'edit'">
            <div class="form-group">
              <label for="progress">Progress</label>
              <select
                name="progress"
                id="progress"
                #progress="ngModel"
                [(ngModel)]="step"
                (change)="changeprogressValue()"
                class="form-control"
              >
                <option value="INTRANSIT">In Transit</option>
                <option value="PICKEDUP">Picked Up</option>
                <option value="RECEIVED">Received</option>
                <!-- <option value='REMOVINGDATABEARINGDEVICES'>Removing Data Bearing Devices</option> -->
                <option value="INMANIFEST">In Manifest</option>
                <option value="INTESTING">In Testing</option>
                <option value="INSALES">In Sales</option>
                <option value="PROCESSED">Processed</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column align-items-center text-center">
          <div *ngIf="action == 'read'">
            <div class="d-flex justify-content-center align-items-center gap-2">
                <h3 *ngIf="guard.permissions('tableProcessingClientName')" class="mt-0 mb-0">
                    {{ item.clientName }}
                </h3>
                <img *ngIf="processingCount != null && processingCount <= 5" src="/assets/img/new-processing.jpg" style="width: 40px; height: auto;" alt="Processing" />
                <img *ngIf="vipStatus == 1" src="/assets/img/vip_company.jpg" style="width: 40px; height: auto;" alt="Vip Company" />
            </div>
            <div class="d-flex justify-content-between align-items-end w-100">
              <div>
                <p>
                  <strong> PO#: {{ item.po.name }} STATUS: </strong>
                  <strong class="text-danger" *ngIf="item.status == 'Voided'">
                    Voided
                  </strong>
                  <strong *ngIf="singleStatus && item.status != 'Voided'">
                    {{ step | Status }}
                  </strong>
                  <strong
                    *ngIf="
                      item.status != 'Voided' &&
                      (itemsOnDepartament.numReceived > 0 ||
                        itemsOnDepartament.num_received_second > 0 ||
                        itemsOnDepartament.num_received_third > 0)
                    "
                  >
                    Received</strong
                  >
                  <strong
                    *ngIf="
                      item.status != 'Voided' &&
                      (itemsOnDepartament.numInmanifest > 0 ||
                        itemsOnDepartament.num_inmanifest_second > 0 ||
                        itemsOnDepartament.num_inmanifest_third > 0)
                    "
                  >
                    {{
                      item.status != "Voided" &&
                        (itemsOnDepartament.numReceived > 0 ||
                        itemsOnDepartament.num_received_second > 0 ||
                        itemsOnDepartament.num_received_third > 0
                          ? "and"
                          : "")
                    }}
                    In Manifest</strong
                  >
                  <strong
                    *ngIf="
                      item.status != 'Voided' &&
                      (itemsOnDepartament.numIntesting > 0 ||
                        itemsOnDepartament.num_intesting_second > 0 ||
                        itemsOnDepartament.num_intesting_third > 0)
                    "
                  >
                    {{
                      item.status != "Voided" &&
                        (itemsOnDepartament.numReceived > 0 ||
                        itemsOnDepartament.num_received_second > 0 ||
                        itemsOnDepartament.num_received_third > 0 ||
                        itemsOnDepartament.numInmanifest > 0 ||
                        itemsOnDepartament.num_inmanifest_second > 0 ||
                        itemsOnDepartament.num_inmanifest_third > 0
                          ? "and"
                          : "")
                    }}
                    In Testing
                  </strong>
                  <strong
                    *ngIf="
                      item.status != 'Voided' &&
                      (itemsOnDepartament.numInsales > 0 ||
                        itemsOnDepartament.num_insales_second > 0 ||
                        itemsOnDepartament.num_insales_third > 0)
                    "
                  >
                    {{
                      item.status != "Voided" &&
                        (itemsOnDepartament.numReceived > 0 ||
                        itemsOnDepartament.num_received_second > 0 ||
                        itemsOnDepartament.num_received_third > 0 ||
                        itemsOnDepartament.numInmanifest > 0 ||
                        itemsOnDepartament.num_inmanifest_second > 0 ||
                        itemsOnDepartament.num_inmanifest_third > 0 ||
                        itemsOnDepartament.numIntesting > 0 ||
                        itemsOnDepartament.num_intesting_second > 0 ||
                        itemsOnDepartament.num_intesting_third > 0
                          ? "and"
                          : "")
                    }}
                    In Sales
                  </strong>
                  <strong
                    *ngIf="
                      item.status != 'Voided' &&
                      (itemsOnDepartament.num_processed > 0 ||
                        itemsOnDepartament.num_processed_second > 0 ||
                        itemsOnDepartament.num_processed_third > 0)
                    "
                  >
                    {{
                      item.status != "Voided" &&
                        (itemsOnDepartament.numReceived > 0 ||
                        itemsOnDepartament.num_received_second > 0 ||
                        itemsOnDepartament.num_received_third > 0 ||
                        itemsOnDepartament.numInmanifest > 0 ||
                        itemsOnDepartament.num_inmanifest_second > 0 ||
                        itemsOnDepartament.num_inmanifest_third > 0 ||
                        itemsOnDepartament.numIntesting > 0 ||
                        itemsOnDepartament.num_intesting_second > 0 ||
                        itemsOnDepartament.num_intesting_third > 0 ||
                        itemsOnDepartament.numInsales > 0 ||
                        itemsOnDepartament.num_insales_second > 0 ||
                        itemsOnDepartament.num_insales_third > 0
                          ? "and"
                          : "")
                    }}
                    Processed
                  </strong>
                </p>
                <button
                  *ngIf="action !== 'delete'"
                  [disabled]="syncPOPending"
                  class="btn btn-warning btn-small"
                  (click)="syncPO(item.po)"
                >
                  <div>
                    <span *ngIf="loadingSync == false; else loader">
                      Sync PO {{ item.po.name }}
                    </span>

                    <ng-template #loader>
                      <span *ngIf="loadingSync == true">
                        <b
                          ><i
                            class="fa fa-spinner fa-pulse fa-3x fa-fw"
                          ></i> </b
                      ></span>
                    </ng-template>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--<div
            style="
              text-align: center;
              border: 2px solid #0373fa;
              border-radius: 180px;
              background-color: #85c1e9;
              width: 50px;
              height: 50px;
            "
            (click)="manifestNew()"
            class="nav-item"
            *ngIf="!procesados()"
          >
            <i
              style="font-size: 2rem; margin-top: 6px"
              class="material-icons text-white"
              >create_new_folder</i
            >
          </div>-->

        <div
          *ngIf="item.hdShredding !== 'No'"
          style="
            text-align: center;
            border: 2px solid #0373fa;
            border-radius: 180px;
            background-color: #85c1e9;
            width: 50px;
            height: 50px;
          "
          (click)="manifestNew2()"
          class="nav-item"
        >
          <i
            style="font-size: 2rem; margin-top: 6px"
            class="material-icons text-white"
            >create_new_folder</i
          >
        </div>
        <!--  New Version of Manifest Hector -->
        <app-batch-pi
          (closeNewBatch)="closeManifest2()"
          [cancel]="true"
          [poId]="poId"
          [piId]="id"
          [poNumber]="poNumber"
          *ngIf="newManifest2"
          (batchCreated)="onBatchCreated($event)"
        ></app-batch-pi>
        <!--<div style="margin-top: 20px; margin-bottom: 20px" *ngIf="newManifest2">
          <div *ngIf="newManifest2_1step">
            <div class="">
              <h2 style="text-align: center; font-size: 2rem">
                Please select a container type
              </h2>
              <hr />
              <div style="padding: 15px" class="row justify-content-center">
                <div
                  *ngFor="let containerType of containersType"
                  (click)="selectContainerType(containerType.name)"
                  class="card"
                  style="width: 10rem; cursor: pointer; margin-right: 20px"
                >
                  <div class="card-body card-bodymanifest text-center">
                    <h5 class="card-title titlebox">
                      {{ containerType.name }}
                    </h5>
                    <span class="material-icons iconbox">
                      {{ containerType.icon }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="newManifest2_2step">
            <div class="">
              <h2 style="text-align: center; font-size: 2rem">
                Please select content type
              </h2>
              <hr />
              <div style="padding: 15px" class="row justify-content-center">
                <div *ngFor="let containerType of contentType" class="col-md-4">
                  <div
                    (click)="selectContentType(containerType.name)"
                    class="card"
                    style="
                      width: 18rem;
                      margin-right: 20px;
                      cursor: pointer;
                      margin: 0 auto;
                    "
                  >
                    <div class="card-body card-bodymanifest text-center">
                      <h5 class="card-title titlebox">
                        {{ containerType.name }}
                      </h5>
                      <span class="material-icons iconbox">
                        {{ containerType.icon }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="newManifest2_3step">
            <h2 style="text-align: center; font-size: 2rem" class="text-center">
              Create new batch
            </h2>
            <hr />

            <form (keydown.enter)="$event.preventDefault()">
              <div
                style="
                  padding: 15px;
                  display: block;
                  width: 600px;
                  margin: 0 auto;
                "
                class="row"
                *ngIf="newContentType == 'HDD/SSD'"
              >
                <div class="row">
                  <div style="width: 100%" class="col-md-6 form-group">
                    <label for="caddiesForm">Do the drives have caddies?</label>
                    <select
                      name="caddiesForm"
                      id="caddiesForm"
                      #caddiesForm="ngModel"
                      [(ngModel)]="caddies"
                      (change)="changecaddies($e)"
                      class="form-control"
                    >
                      <option value="">Please select an option</option>
                      <option value="YesALL">Yes - All</option>
                      <option value="YesSome">Yes - Some</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div style="width: 100%" class="col-md-6 form-group">
                    <label for="batchPriorityForm">Batch Priority Level</label>
                    <select
                      name="batchPriorityForm"
                      id="batchPriorityForm"
                      #batchPriorityForm="ngModel"
                      [(ngModel)]="batchPriorityLevel"
                      class="form-control"
                    >
                      <option value="">Please select an option</option>
                      <option value="Low Priority">Low Priority</option>
                      <option value="Medium Priority">Medium Priority</option>
                      <option value="Fast Priority">Fast Priority</option>
                      <option value="Urgent Priority">Urgent Priority</option>
                    </select>
                  </div>
                </div>
                <div class="d-flex">
                  <div style="width: 100%" class="form-group w-100 mr-3">
                    <mat-form-field class="example-full-width">
                      <mat-label>Quantity of HDD?</mat-label>
                      <input
                        type="number"
                        min="0"
                        (keypress)="mtds.onlyNumber($event)"
                        name="hdd_qty"
                        [(ngModel)]="hardDrives"
                        matInput
                        required
                        [disabled]="newContentType != 'HDD/SSD'"
                      />
                    </mat-form-field>
                  </div>
                  <div style="width: 100%" class="form-group w-100">
                    <mat-form-field class="example-full-width">
                      <mat-label>Quantity of SSD?</mat-label>
                      <input
                        type="number"
                        min="0"
                        (keypress)="mtds.onlyNumber($event)"
                        name="ssd_qty"
                        [(ngModel)]="ssd"
                        matInput
                        required
                        [disabled]="newContentType != 'HDD/SSD'"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div
                style="
                  padding: 15px;
                  display: block;
                  width: 600px;
                  margin: 0 auto;
                "
                class="row"
                *ngIf="newContentType == 'Devices'"
              >
                <div style="width: 100%" class="col-md-12 form-group">
                  <label for="batchPriorityForm">Batch Priority Level</label>
                  <select
                    name="batchPriorityForm"
                    id="batchPriorityForm"
                    #batchPriorityForm="ngModel"
                    [(ngModel)]="batchPriorityLevel"
                    class="form-control"
                  >
                    <option value="">Please select an option</option>
                    <option value="Low Priority">Low Priority</option>
                    <option value="Medium Priority">Medium Priority</option>
                    <option value="Fast Priority">Fast Priority</option>
                    <option value="Urgent Priority">Urgent Priority</option>
                  </select>
                </div>
                <div class="d-flex">
                  <div style="width: 100%" class="form-group w-100 mr-3">
                    <mat-form-field class="example-full-width">
                      <mat-label> Quantity of Desktops?</mat-label>

                      <input
                        type="number"
                        min="0"
                        (keypress)="mtds.onlyNumber($event)"
                        name="hdd_qty"
                        [(ngModel)]="desktops"
                        matInput
                        required
                        [disabled]="newContentType == 'HDD/SSD'"
                      />
                    </mat-form-field>
                  </div>
                  <div style="width: 100%" class="form-group w-100">
                    <mat-form-field class="example-full-width">
                      <mat-label>Quantity of All in One?</mat-label>

                      <input
                        type="number"
                        min="0"
                        (keypress)="mtds.onlyNumber($event)"
                        name="ssd_qty"
                        [(ngModel)]="allInOne"
                        matInput
                        required
                        [disabled]="newContentType == 'HDD/SSD'"
                      />
                    </mat-form-field>
                  </div>
                  <div style="width: 100%" class="form-group w-100">
                    <mat-form-field class="example-full-width">
                      <mat-label>Quantity of Laptops?</mat-label>

                      <input
                        style="margin-top: 10px"
                        type="number"
                        min="0"
                        (keypress)="mtds.onlyNumber($event)"
                        name="ssd_qty"
                        [(ngModel)]="laptops"
                        matInput
                        required
                        [disabled]="newContentType == 'HDD/SSD'"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div
                style="
                  padding: 15px;
                  display: block;
                  width: 600px;
                  margin: 0 auto;
                "
                class="row"
                *ngIf="newContentType == 'Mobile Devices'"
              >
                <div class="d-flex">
                  <div
                    style="width: 100%; padding-left: 0px"
                    class="col-md-6 form-group w-100 mr-3"
                  >
                    <mat-form-field class="example-full-width">
                      <mat-label
                        style="
                          margin-bottom: 50px;
                          font-size: 18px;
                          font-weight: 300;
                        "
                      >
                        Quantity of Mobile Devices?</mat-label
                      >

                      <input
                        type="number"
                        min="0"
                        (keypress)="mtds.onlyNumber($event)"
                        name="mobiledevices_qty"
                        [(ngModel)]="mobileDevices"
                        matInput
                        required
                        style="margin-top: 10px"
                      />
                    </mat-form-field>
                  </div>
                  <div style="width: 100%" class="col-md-6 form-group">
                    <label style="font-weight: 200" for="batchPriorityForm"
                      >Batch Priority Level</label
                    >
                    <select
                      name="batchPriorityForm"
                      id="batchPriorityForm"
                      #batchPriorityForm="ngModel"
                      [(ngModel)]="batchPriorityLevel"
                      class="form-control"
                    >
                      <option value="">Please select an option</option>
                      <option value="Low Priority">Low Priority</option>
                      <option value="Medium Priority">Medium Priority</option>
                      <option value="Fast Priority">Fast Priority</option>
                      <option value="Urgent Priority">Urgent Priority</option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                style="
                  padding: 15px;
                  display: block;
                  width: 600px;
                  margin: 0 auto;
                "
                class="row"
              >
                <div style="width: 550px" class="d-flex">
                  <div class="form-group w-100 mr-3">
                    <mat-label>Total Weight (Lbs)</mat-label>

                    <input
                      type="number"
                      min="0.00"
                      step="1"
                      class="form-control currency"
                      placeholder="00.00"
                      name="totalWeightForm"
                      [(ngModel)]="newcontainerWeight"
                      (change)="sumarPesoNewContainer()"
                      required
                    />
                  </div>
                  <div class="form-group w-100">
                    <mat-label>NET Weight (Lbs)</mat-label>

                    <input
                      type="number"
                      min="0.01"
                      step="0.01"
                      class="form-control currency"
                      placeholder="00.00"
                      name="totalNetWeightForm"
                      [(ngModel)]="newcontainerTotalNetWeight"
                      disabled
                    />
                  </div>
                </div>
                <div class="form-group w-100">
                  <label *ngIf="loadingLocationsNewContainer"
                    >Location <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
                  ></label>

                  <app-filter-object
                    *ngIf="!loadingLocationsNewContainer"
                    [options]="locationsListNewContainer"
                    placeholder="Locations"
                    [value]="newcontainerInternallocation_id"
                    (selectChange)="changeLocationNewContainer($event)"
                    [disabled]="locationsListNewContainer.length == 0"
                  >
                  </app-filter-object>
                  <div class="row">
                    <div class="col-md-6">
                      <mat-checkbox (change)="onCheckboxChange($event)"
                        >Show External Locations</mat-checkbox
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label *ngIf="loadingUsers"
                      >Loading Users
                      <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
                    ></label>

                    <app-filter-object
                      *ngIf="!loadingUsers"
                      [options]="usersList"
                      placeholder="Assign User"
                      [value]="assignTo"
                      (selectChange)="assignTo = $event.id"
                    >
                    </app-filter-object>
                  </div>
                </div>

                <div
                  *ngIf="
                    newcontainerInternallocation_id != null &&
                    newcontainerInternallocation_id != 0
                  "
                  class="comentarios-batch row"
                >
                  <app-comments
                    style="width: 100%"
                    [id_phather]="idmanifestSelected"
                    type_chat="BATCH"
                    type_notification=""
                    (receive_item_id)="receive_chatitem_id($event)"
                    [item]="{
                      caddies: caddies,
                      hardDrives: hardDrives,
                      ssd: ssd,
                      desktops: desktops,
                      allInOne: allInOne,
                      laptops: laptops,
                      newcontainerWeight: newcontainerWeight,
                      newcontainerTotalNetWeight: newcontainerTotalNetWeight,
                      newcontainerInternallocation_id:
                        newcontainerInternallocation_id,
                      processing_instruction_id: id,
                      newContentType: newContentType,
                      newContainerType: newContainerType
                    }"
                    [disabled]="false"
                  ></app-comments>
                </div>

                <div class="text-center" style="width: 100%">
                  <button
                    [disabled]="
                      newcontainerWeight < 1 ||
                      newcontainerInternallocation_id == 0
                    "
                    class="btn btn-success btn-block"
                    (click)="saveManifestNew()"
                  >
                    Create Batch
                  </button>
                </div>
              </div>
            </form>
          </div>

          <button (click)="closeManifest2()" class="btn btn-danger">
            Cancel
          </button>
        </div>-->
        <!--  New Version of Manifest Hector -->

        <div
          *ngIf="!newManifest2"
          class="modal-header"
          style="text-align: center"
        >
          <app-progress
            style="width: 100%"
            *ngIf="action == 'read'"
            [po]="item.po.name"
            [step]="step"
            [itemsOnDepartament]="itemsOnDepartament"
            (newstep)="cambiarestatus($event)"
            [cant_locations_in_manifest]="cant_locations_in_manifest"
            [cant_locations_in_sales]="cant_locations_in_sales"
            [cant_locations_in_testing]="cant_locations_in_testing"
            [cant_locations_processed]="cant_locations_processed"
            [cant_locations_received]="cant_locations_received"
            [cant_locations_shipped]="cant_locations_shipped"
          ></app-progress>
        </div>
        <div
          *ngIf="
            action != 'create' &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
          style="width: 100%; position: relative"
        >
          <div style="height: 60px"></div>
        </div>
        <br />
        <div>
          <div class="" *ngIf="cargandoBatch" style="text-align: center">
            <h2>
              <b
                ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                Loading...</b
              >
            </h2>
          </div>
          <div
            class=""
            *ngIf="
              !newManifest2 &&
              ((itemsManifest && itemsManifest.length) ||
                (itemsManifestNew && itemsManifestNew.length))
            "
          >
            <div class="accordion" id="accordionExample">
              <div class="card">
                <!-- <div class="card-header" id="headingOne">
                   <h2 class="mb-0">
                      <a
                        class="btn btn-link btn-block text-left"
                        style="color: black; font-size: 15px"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        (click)="showhide = !showhide"
                      >
                        <span class="material-icons">
                          {{ showhide ? "visibility" : "visibility_off" }}
                        </span>
                        {{ showhide ? "Show" : "Hide" }}
                      </a>
                    </h2>
                  </div>-->
                <div
                  class="row"
                  style="position: relative; margin-bottom: 25px"
                >
                  <div class="col-md-12">
                    <h2 class="d-flex justify-content-center">
                      <b style="font-size: 18px">Batch Containers</b>
                    </h2>
                    <div
                      style="justify-content: center"
                      class="row text-center"
                    >
                      <div class="col-md-3 col-sm-4">
                        <button
                          (click)="filtrarMI('ALL')"
                          mat-raised-button
                          style="color: black"
                          class="btn btn-link btn-dark"
                          [ngClass]="{
                            borderselected: filtroMI == 'ALL'
                          }"
                        >
                          <span class="material-icons"> inbox </span> All ·
                          {{ granTotalMI }}
                        </button>
                      </div>
                      <div class="col-md-3 col-sm-4">
                        <button
                          (click)="filtrarMI('Pending')"
                          mat-raised-button
                          class="btn btn-link btn-danger"
                          [ngClass]="{
                            borderselected: filtroMI == 'Pending'
                          }"
                        >
                          <span class="material-icons"> inbox </span>
                          Pending · {{ cant_pending }}
                        </button>
                      </div>
                      <div class="col-md-3 col-sm-4">
                        <button
                          (click)="filtrarMI('In Progress')"
                          mat-raised-button
                          class="btn btn-link btn-warning"
                          [ngClass]="{
                            borderselected: filtroMI == 'In Progress'
                          }"
                        >
                          <span class="material-icons"> inbox </span> In
                          Progress · {{ cant_in_progress }}
                        </button>
                      </div>
                      <div class="col-md-3 col-sm-4">
                        <button
                          (click)="filtrarMI('Completed')"
                          mat-raised-button
                          class="btn btn-link btn-success"
                          [ngClass]="{
                            borderselected: filtroMI == 'Completed'
                          }"
                        >
                          <span class="material-icons"> inbox </span>
                          Completed · {{ cant_completed }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="isCollapsedVisible"
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div
                    class="card-body"
                    [ngStyle]="{
                      height: itemsManifest.length >= 4 ? '700px' : 'auto',
                      'overflow-y':
                        itemsManifest.length >= 4 ? 'scroll' : 'hidden'
                    }"
                  >
                    <div
                      *ngFor="let item of itemsManifest"
                      style="position: relative; margin-bottom: 25px"
                    >
                      <div class="esferas d-flex justify-content-between">
                        <div class="liner"></div>
                        <label>#{{ item.batch }}</label>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.hardDrivesDone == '1'
                                  ? 'bde-active'
                                  : 'clk bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="
                                item.hardDrivesDone == '1'
                                  ? finished(
                                      'HARDDRIVES',
                                      item.id,
                                      item.hardDrivesDone,
                                      false
                                    )
                                  : finished(
                                      'HARDDRIVES',
                                      item.id,
                                      item.hardDrivesDone,
                                      true
                                    )
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Completed by {{ item.repNameHardDrives }}"
                              style="cursor: pointer"
                            >
                              <span class="material-icons">disc_full</span>
                              <span
                                *ngIf="item.hardDrives > 0"
                                class="badge top-right"
                                >{{ item.hardDrives }}</span
                              >
                            </button>
                          </div>
                          <label>Hard Drives</label>
                        </div>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.laptopsDone == '1'
                                  ? 'bde-active'
                                  : 'clk bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="
                                item.laptopsDone == '1'
                                  ? finished(
                                      'LAPTOPS',
                                      item.id,
                                      item.laptopsDone,
                                      false
                                    )
                                  : finished(
                                      'LAPTOPS',
                                      item.id,
                                      item.laptopsDone,
                                      true
                                    )
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Completed by {{ item.repNameLaptops }}"
                              style="cursor: pointer"
                            >
                              <span class="material-icons">laptop</span>
                              <span
                                *ngIf="item.laptops > 0"
                                class="badge top-right"
                                >{{ item.laptops }}</span
                              >
                            </button>
                          </div>
                          <label>Laptops</label>
                        </div>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.desktopsDone == '1'
                                  ? 'bde-active'
                                  : 'clk bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="
                                item.desktopsDone == '1'
                                  ? finished(
                                      'DESKTOPS',
                                      item.id,
                                      item.desktopsDone,
                                      false
                                    )
                                  : finished(
                                      'DESKTOPS',
                                      item.id,
                                      item.desktopsDone,
                                      true
                                    )
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Completed by {{ item.repNameDesktops }}"
                              style="cursor: pointer"
                            >
                              <span class="material-icons"
                                >desktop_windows</span
                              >
                              <span
                                *ngIf="item.desktops > 0"
                                class="badge top-right"
                                >{{ item.desktops }}</span
                              >
                            </button>
                          </div>
                          <label>Desktops</label>
                        </div>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.allinoneDone == '1'
                                  ? 'bde-active'
                                  : 'clk bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="
                                item.allinoneDone == '1'
                                  ? finished(
                                      'ALLINONE',
                                      item.id,
                                      item.allinoneDone,
                                      false
                                    )
                                  : finished(
                                      'ALLINONE',
                                      item.id,
                                      item.allinoneDone,
                                      true
                                    )
                              "
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Completed by {{ item.repNameAllInOne }}"
                              style="cursor: pointer"
                            >
                              <span class="material-icons">devices</span>
                              <span
                                *ngIf="item.allInOne > 0"
                                class="badge top-right"
                                >{{ item.allInOne }}</span
                              >
                            </button>
                          </div>
                          <label>All In One</label>
                        </div>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.containersDone == '1'
                                  ? 'bde-active'
                                  : 'clk bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="
                                item.containersDone == '1'
                                  ? finished(
                                      'CONTAINERS',
                                      item.id,
                                      item.containersDone,
                                      false
                                    )
                                  : finished(
                                      'CONTAINERS',
                                      item.id,
                                      item.containersDone,
                                      true
                                    )
                              "
                            >
                              <span class="material-icons">storage</span>
                              <span
                                *ngIf="item.containers > 0"
                                class="badge top-right"
                                >{{ item.containers }}</span
                              >
                            </button>
                          </div>
                          <label>Containers for HDD?</label>
                        </div>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.containersDevicesDone == '1'
                                  ? 'bde-active'
                                  : 'clk bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="
                                item.containersDevicesDone == '1'
                                  ? finished(
                                      'CONTAINERSDEVICES',
                                      item.id,
                                      item.containersDevicesDone,
                                      false
                                    )
                                  : finished(
                                      'CONTAINERSDEVICES',
                                      item.id,
                                      item.containersDevicesDone,
                                      true
                                    )
                              "
                            >
                              <span class="material-icons">storage</span>
                              <span
                                *ngIf="item.containersDevices > 0"
                                class="badge top-right"
                                >{{ item.containersDevices }}</span
                              >
                            </button>
                          </div>
                          <label>Containers for Devices?</label>
                        </div>
                        <div class="bde-container">
                          <div class="g1">
                            <button
                              type="button"
                              [ngClass]="[
                                item.laptopsDone === 1 &&
                                item.hardDrivesDone === 1 &&
                                item.desktopsDone === 1 &&
                                item.allinoneDone === 1
                                  ? 'bde-active'
                                  : 'bde-inactive'
                              ]"
                              class="icon-button"
                              (click)="log(item)"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Completed by {{ item.repNameBatchDone }}"
                              style="cursor: pointer"
                            >
                              <span class="material-icons">done</span>
                            </button>
                          </div>
                          <label>Complete</label>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end mt-2 mb-4">
                        <i
                          style="
                            cursor: pointer;
                            color: rgba(26, 187, 199, 0.795);
                          "
                          class="material-icons btn-link btn-just-icon"
                          (click)="splitItem(item)"
                          *ngIf="
                            item.laptopsDone !== 1 ||
                            item.hardDrivesDone !== 1 ||
                            item.desktopsDone !== 1 ||
                            item.allinoneDone !== 1
                          "
                          >call_split</i
                        >
                        <!-- &nbsp; -->
                        <i
                          style="
                            cursor: pointer;
                            color: rgba(26, 187, 199, 0.795);
                          "
                          class="material-icons btn-link btn-just-icon"
                          (click)="showItemManifest(item)"
                          >remove_red_eye</i
                        >
                        <!-- &nbsp; -->
                        <i
                          style="cursor: pointer; color: black"
                          class="material-icons btn-link btn-just-icon"
                          (click)="printItemManifest(item)"
                          >local_printshop</i
                        >
                        <!-- &nbsp; -->
                        <i
                          style="cursor: pointer; color: red"
                          class="material-icons btn-link btn-just-icon"
                          (click)="deletManiest_id = item.id"
                          >delete_forever</i
                        >
                      </div>
                    </div>

                    <!-- <div style="position: relative; margin-bottom: 25px">
                      <div *ngFor="let item of itemsManifestNew">
                        <app-batch
                          [item]="item"
                          [whs_id]="whs_id"
                          (closeManifest)="getItemsManifest()"
                        ></app-batch>
                      </div>
                    </div> -->
                    <mat-accordion disabled hideToggle>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <!-- Puedes personalizar el título con información de `item` -->
                            BATCH NUMBER
                          </mat-panel-title>

                          <mat-panel-title>
                            <!-- Agrega detalles del ítem si es necesario -->
                            BREAKDOWN
                          </mat-panel-title>
                          <mat-panel-title>
                            <!-- Agrega detalles del ítem si es necesario -->
                            PRIORITY
                          </mat-panel-title>
                          <mat-panel-title>
                            <!-- Agrega detalles del ítem si es necesario -->
                            CREATOR
                          </mat-panel-title>
                          <mat-panel-title>
                            <!-- Agrega detalles del ítem si es necesario -->
                            ERASURE REPORT
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <mat-accordion>
                      <mat-expansion-panel
                        *ngFor="let item of itemsManifestNew"
                      >
                        <mat-expansion-panel-header>
                          <mat-panel-description>
                            <span
                              class="material-icons"
                              *ngIf="
                                getStatusProperties(item.status) as statusProps
                              "
                              [style.color]="statusProps.iconColor"
                              style="padding-right: 4px; font-size: 10px"
                            >
                              {{ statusProps.icon }}
                            </span>
                            #{{ item.batch }}
                          </mat-panel-description>

                          <mat-panel-description>
                            <div class="mr-2" *ngIf="item.hardDrives">
                              HDD: {{ item.hardDrives
                              }}<span *ngIf="item.ssd">,</span>
                            </div>
                            <div class="mr-2" *ngIf="item.ssd">
                              SSD: {{ item.ssd }}
                            </div>
                            <div class="mr-2" *ngIf="item.allInOne">
                              AIO: {{ item.allInOne
                              }}<span *ngIf="item.laptops || item.desktops"
                                >,</span
                              >
                            </div>
                            <div class="mr-2" *ngIf="item.laptops">
                              Laptops: {{ item.laptops
                              }}<span *ngIf="item.desktops">,</span>
                            </div>
                            <div class="mr-2" *ngIf="item.desktops">
                              Desktops: {{ item.desktops }}
                            </div>
                            <div *ngIf="item.mobileDevices">
                              Mobile Devices: {{ item.mobileDevices }}
                            </div>
                          </mat-panel-description>
                          <mat-panel-description>
                            {{ priorityLevel }}
                          </mat-panel-description>

                          <mat-panel-description>
                            {{ item.rep?.name.charAt(0).toUpperCase()
                            }}{{ item.rep?.surname.charAt(0).toUpperCase() }}
                          </mat-panel-description>
                          <mat-panel-description>
                            {{ item.erasureReport }}
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                          <!-- Componente hijo con los datos del ítem -->
                          <app-batch
                            [item]="item"
                            [whs_id]="whs_id"
                            (closeManifest)="getItemsManifest()"
                            (statusChanged)="onStatusChanged($event)"
                          ></app-batch>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                  <nav style="overflow: auto" class="ml-3" aria-label="...">
                    <ul class="pagination">
                      <li
                        class="page-item"
                        [ngClass]="{
                          disabled: manifest_count_actual_page == 1
                        }"
                      >
                        <a
                          class="page-link"
                          (click)="goPrevMI($event)"
                          href="#"
                          tabindex="-1"
                          >Previous</a
                        >
                      </li>

                      <li
                        class="page-item"
                        *ngFor="let p of pages"
                        [ngClass]="{
                          active: manifest_count_actual_page == p + 1
                        }"
                      >
                        <a
                          (click)="gotoPageMI($event, p + 1)"
                          class="page-link"
                          href="#"
                          >{{ p + 1 }}
                          <span
                            *ngIf="manifest_count_actual_page == p + 1"
                            class="sr-only"
                            >(current)</span
                          >
                        </a>
                      </li>

                      <li
                        class="page-item"
                        (click)="goNextMI($event)"
                        [ngClass]="{
                          disabled:
                            manifest_count_actual_page == pages.length + 1
                        }"
                      >
                        <a class="page-link" href="#">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div
          *ngIf="
            action == 'read' &&
            !newManifest &&
            !newManifest2 &&
            !splitManifest &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
          class=""
          style="text-align: center"
        >
          <div class="" style="text-align: right">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-outline-info dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fa fa-columns" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu">
                <a
                  class="dropdown-item pinter"
                  *ngFor="let option of options"
                  [ngClass]="{ visible: option.visibility }"
                  (click)="
                    option.visibility = !option.visibility; updateConfig()
                  "
                  >{{ option.colName }}</a
                >
              </div>
            </div>
          </div>
          <div class="" *ngIf="options.length">
            <nav class="nav nav-tabs justify-content-between">
              <div
                *ngFor="let option of options; let i = index"
                [attr.data-index]="i"
              >
                <div
                  *ngIf="options[i].visibility"
                  class="nav-item nav-link"
                  [ngClass]="{ active: tab == option.tab }"
                  (click)="changeTab(option.tab)"
                >
                  <i class="material-icons">{{ option.icon }}</i> <br />
                  <span
                    *ngIf="numFiles && option.colName == 'FILES'"
                    class="badge top-right-red"
                    >{{ numFiles }}</span
                  >
                  <span
                    *ngIf="chats.length && option.colName == 'NOTES'"
                    class="badge top-right-red"
                    >{{ chats.length }}</span
                  >
                  <a>{{ option.colName }}</a>
                </div>
              </div>
            </nav>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <!-- <h3 class="title-section">{{ title }}</h3> -->
            <!-- <button *ngIf="action == 'read'" type="button" class="btn btn-warning btn-md" (click)="action = 'update'">
                                          Edit
                                      </button>-->
          </div>
        </div>
        <!-- --------------------------------------Seccion 1------------------------------------------ -->
        <div *ngIf="changeStatus">
          <div>
            <div class="">
              <div class="form-group">
                <label>Change Status</label>
                <select
                  name="asignacion"
                  #asignacion="ngModel"
                  [(ngModel)]="nuevoStatus"
                  class="form-control"
                  required
                >
                  <option value="INTRANSIT">IN TRANSIT</option>
                  <option value="PICKEDUP">PICKEDUP</option>
                  <option value="RECEIVED">RECEIVED</option>
                  <option value="REMOVINGDATABEARINGDEVICES">
                    REMOVING DATA BEARINGDEVICES
                  </option>
                  <option value="INMANIFEST">IN MANIFEST</option>
                  <option value="INTESTING">IN TESTING</option>
                  <option value="INSALES">IN SALES</option>
                  <option value="PROCESSED">PROCESSED</option>
                </select>
              </div>
            </div>
          </div>
          <div>
            <div class="" style="text-align: right">
              <button class="btn btn-danger btn-sm" (click)="cancelAssign()">
                <i class="fa fa-reply" aria-hidden="true"></i> BACK
              </button>
              &nbsp;
              <button class="btn btn-success btn-sm" (click)="cambiarStatus()">
                CHANGE
              </button>
            </div>
          </div>
        </div>
        <div></div>
        <div *ngIf="erasure">
          <div>
            <div
              class=""
              *ngIf="
                typeErasure !== 'CONTAINERS' &&
                typeErasure !== 'CONTAINERSDEVICES'
              "
            >
              <h3>
                <i
                  class="fa fa-exclamation-triangle fa-2x"
                  style="color: red"
                  *ngIf="
                    typeErasure === 'PROCESSED' && manifestFinish === false
                  "
                  aria-hidden="true"
                ></i>
                {{ question }}
              </h3>
            </div>
            <div
              class=""
              *ngIf="
                typeErasure === 'CONTAINERS' ||
                typeErasure === 'CONTAINERSDEVICES'
              "
            >
              <mat-form-field class="example-full-width">
                <mat-label>{{ question }}</mat-label>
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="containers-processed"
                  [(ngModel)]="containersProcessed"
                  matInput
                  required
                />
              </mat-form-field>
            </div>
            <div
              class=""
              *ngIf="
                (typeErasure === 'CONTAINERS' ||
                  typeErasure === 'CONTAINERSDEVICES') &&
                errorContainers
              "
            >
              <div class="alert alert-danger" role="alert">
                The number can't be greater than the number of containers
              </div>
            </div>
          </div>
          <div
            *ngIf="
              typeErasure !== 'CONTAINERS' &&
              typeErasure !== 'CONTAINERSDEVICES'
            "
          >
            <div class="" style="text-align: right">
              <button class="btn btn-danger btn-sm" (click)="closeErasure()">
                <i class="fa fa-reply" aria-hidden="true"></i>
                {{
                  typeErasure !== "PROCESSED" || manifestFinish === true
                    ? "No"
                    : "back"
                }}
              </button>
              <button
                *ngIf="typeErasure !== 'PROCESSED' || manifestFinish === true"
                class="btn btn-success btn-sm"
                (click)="setDone()"
                [disabled]="finishedBashed"
              >
                Yes
              </button>
            </div>
          </div>
          <div
            *ngIf="
              typeErasure === 'CONTAINERS' ||
              typeErasure === 'CONTAINERSDEVICES'
            "
          >
            <div class="" style="text-align: right">
              <button class="btn btn-danger btn-sm" (click)="closeErasure()">
                <i class="fa fa-reply" aria-hidden="true"></i>
                Back
              </button>
              <button
                class="btn btn-success btn-sm"
                (click)="saveContainers()"
                [disabled]="containersProcessed === 0"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="deletManiest_id != null">
          <div>
            <div class="">
              <h3>Are you sure you want to delete this batch?</h3>
            </div>
          </div>
          <div>
            <div class="" style="text-align: right">
              <button
                class="btn btn-success btn-sm"
                (click)="deletManiest_id = null"
              >
                <i class="fa fa-reply" aria-hidden="true"></i> Cancel
              </button>
              <button class="btn btn-danger btn-sm" (click)="deleteManifest()">
                Delete
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="newManifest" class="grid-container">
          <mat-form-field class="example-full-width">
            <mat-label>Quantity of Hard Drives?</mat-label>

            <input
              type="number"
              min="0"
              ng-pattern="onlyNumbers"
              placeholder="Quantity of Hard Drives?"
              (keypress)="mtds.onlyNumber($event)"
              name="hard-drives"
              [(ngModel)]="hardDrives"
              matInput
              required
              [disabled]="itemManifestID != null"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Number of Containers for HDD?</mat-label>

            <input
              type="number"
              min="0"
              placeholder="Number of Containers for HDD?"
              (keypress)="mtds.onlyNumber($event)"
              name="_containers"
              [(ngModel)]="containers"
              matInput
              required
              [disabled]="itemManifestID != null"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Quantity of Desktops?</mat-label>

            <input
              type="number"
              min="0"
              placeholder="Quantity of Desktops?"
              (keypress)="mtds.onlyNumber($event)"
              name="desktops"
              [(ngModel)]="desktops"
              matInput
              required
              [disabled]="itemManifestID != null"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Quantity of All In One?</mat-label>

            <input
              type="number"
              min="0"
              placeholder="Quantity of All In One?"
              (keypress)="mtds.onlyNumber($event)"
              name="allInOne"
              [(ngModel)]="allInOne"
              matInput
              required
              [disabled]="itemManifestID != null"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Quantity of Laptops?</mat-label>

            <input
              type="number"
              placeholder=" Quantity of Laptops?"
              min="0"
              (keypress)="mtds.onlyNumber($event)"
              name="lap-tops"
              [(ngModel)]="laptops"
              matInput
              required
              [disabled]="itemManifestID != null"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label class="readonly-label"
              >Number of Containers for Devices?</mat-label
            >
            &nbsp;
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              matTooltip="Laptops, Desktops & AIO"
              matTooltipPosition="right"
              style="cursor: pointer"
            ></i>
            &nbsp;
            <small *ngIf="showPopLabel">Laptops, Desktops & AIO</small>
            <input
              type="number"
              placeholder=""
              min="0"
              (keypress)="mtds.onlyNumber($event)"
              name="_containersDevices"
              [(ngModel)]="containersDevices"
              matInput
              required
              [disabled]="itemManifestID != null"
            />
          </mat-form-field>
          <div></div>
          <div class="" style="text-align: right">
            <button class="btn btn-danger btn-sm" (click)="closeManifest()">
              <i class="fa fa-reply" aria-hidden="true"></i> Back
            </button>
            <button
              *ngIf="itemManifestID == null"
              class="btn btn-success btn-sm"
              (click)="saveManifest()"
              [disabled]="!f.valid || saveManifestB"
            >
              Save
            </button>
          </div>
        </div>

        <div *ngIf="splitManifest">
          <div class="row">
            <div class="col-4">
              <mat-form-field class="example-full-width has-label">
                <label
                  ><span class="material-icons">disc_full</span> Quantity of
                  Hard Drives?</label
                >
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="hard-drives-split"
                  [(ngModel)]="hardDrivesSplit"
                  matInput
                  required
                  [disabled]="hardDrivesDone === 1"
                />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field class="example-full-width has-label">
                <label
                  ><span class="material-icons">storage</span> Number of
                  Containers for HDD?</label
                >
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="containersSplit"
                  [(ngModel)]="containersSplit"
                  matInput
                  required
                  [disabled]="hardDrivesDone === 1"
                />
              </mat-form-field>
            </div>
            <div class=""></div>
          </div>
          <div>
            <mat-form-field class="example-full-width has-label">
              <label
                ><span class="material-icons">desktop_windows</span> Quantity of
                Desktops?</label
              >
              <input
                type="number"
                min="0"
                (keypress)="mtds.onlyNumber($event)"
                name="desktopsSplit"
                [(ngModel)]="desktopsSplit"
                matInput
                required
                [disabled]="desktopsDone === 1"
              />
            </mat-form-field>
            <mat-form-field class="example-full-width has-label">
              <label
                ><span class="material-icons">devices</span> Quantity of All In
                One?</label
              >
              <input
                type="number"
                min="0"
                (keypress)="mtds.onlyNumber($event)"
                name="allInOneSplit"
                [(ngModel)]="allInOneSplit"
                matInput
                required
                [disabled]="allInOneDone === 1"
              />
            </mat-form-field>

            <mat-form-field class="example-full-width has-label">
              <label
                ><span class="material-icons">laptop</span> Quantity of
                Laptops?</label
              >
              <input
                type="number"
                min="0"
                (keypress)="mtds.onlyNumber($event)"
                name="lap-tops-split"
                [(ngModel)]="laptopsSplit"
                matInput
                required
                [disabled]="laptopsDone === 1"
              />
            </mat-form-field>
            <mat-form-field class="example-full-width">
              <label class="readonly-label d-flex"
                ><span class="material-icons">storage</span> Number of
                Containers for Devices?</label
              >
              &nbsp;
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                (click)="showPop()"
                style="cursor: pointer"
              ></i>
              &nbsp;
              <small *ngIf="showPopLabel">Laptops, Desktops & AIO</small>
              <input
                type="number"
                min="0"
                (keypress)="mtds.onlyNumber($event)"
                name="containersDevicesSplit"
                [(ngModel)]="containersDevicesSplit"
                matInput
                required
                [disabled]="
                  desktopsDone === 1 && allInOneDone === 1 && laptopsDone === 1
                "
              />
            </mat-form-field>
          </div>
          <div>
            <div class="" *ngIf="errorHardDrives">
              <div class="alert alert-danger" role="alert">
                The number of Hard Drives can't be greater
              </div>
            </div>
            <div class="" *ngIf="errorLaptops">
              <div class="alert alert-danger" role="alert">
                The number of Laptops can't be greater
              </div>
            </div>
            <div class="" *ngIf="errorAllInOne">
              <div class="alert alert-danger" role="alert">
                The number of All In One can't be greater
              </div>
            </div>
            <div class="" *ngIf="errorDesktops">
              <div class="alert alert-danger" role="alert">
                The number of Desktops can't be greater
              </div>
            </div>
          </div>
          <div>
            <div class="" style="text-align: right">
              <button class="btn btn-danger btn-sm" (click)="closeManifest()">
                <i class="fa fa-reply" aria-hidden="true"></i> Back
              </button>
              <button
                class="btn btn-success btn-sm"
                (click)="saveSplitManifest()"
                [disabled]="
                  (containersDevicesSplit === 0 && containersSplit === 0) ||
                  ((containersDevicesSplit !== 0 || containersSplit !== 0) &&
                    laptopsSplit == 0 &&
                    desktopsSplit == 0 &&
                    allInOneSplit == 0 &&
                    hardDrivesSplit == 0) ||
                  saveSplit
                "
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <!-- --------------------------------------Seccion 11------------------------------------------ -->
        <div
          *ngIf="
            tab == 11 &&
            !newManifest &&
            !newManifest2 &&
            !splitManifest &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
        >
          <app-tickets
            [weigths_number]="total_items_count"
            [po_id]="item.po.id"
            [po_number]="item.po.name"
            [pi_id]="item.id"
            [whs_id]="whs_id"
            (changeLocations)="changeItemLocations($event)"
          ></app-tickets>
        </div>
        <!-- --------------------------------------Seccion 12------------------------------------------ -->
        <div
          *ngIf="
            tab === 12 &&
            !newManifest &&
            !newManifest2 &&
            !splitManifest &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
        >
          <div>
            <div>
              <h4 *ngIf="!editHistory">Add New Reminder</h4>
              <h4 *ngIf="editHistory">Edit Reminder</h4>
            </div>
            <div class="grid-container">
              <mat-form-field class="example-full-width mt-4">
                <mat-label>REP</mat-label>
                <input
                  type="text"
                  value="{{ identity.name }} {{ identity.surname }}"
                  readonly
                  matInput
                  placeholder="REP"
                  disabled
                />
              </mat-form-field>
              <!-- <div class="form-group">
                  <label class="bmd-label-floating">REP</label>
                  <input
                    type="text"
                    class="form-control"
                    value="{{ identity.name }} {{ identity.surname }}"
                    readonly
                  />
                </div> -->
            </div>
            <!--  <div class="">
                <div class="form-group">
                  <div class="form-group">
                    <label for="fechacontacto">Contact Date</label>
                    <input type="date" class="form-control" name="fechacontacto" #fechacontacto="ngModel" [(ngModel)]="contacthistory.fechacontacto">
                  </div>
                </div>
              </div>
              <div class="">
                <div class="form-group">
                  <label class="bmd-label-floating">Contact Hour</label>
                  <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="horacontacto" #horacontacto="ngModel" [(ngModel)]="contacthistory.horacontacto" >
                </div>
              </div>-->
            <!-- <div >
                <div class="form-group">
                  <label class="bmd-label-floating">Send a Reminder?</label>
                  <select name="reminder" id="reminder" class="form-control" #reminder="ngModel" [(ngModel)]="contacthistory.reminder" required>
                    <option value=null disabled>Please select an option</option>
                    <option value='YES'>Yes</option>
                    <option value='NO'>No</option>
                  </select>
                </div>
              </div>-->
            <div
              *ngIf="contacthistory.reminder == 'YES'"
              class="grid-container"
            >
              <div class="form-group">
                <label for="Date">Reminder Date</label>
                <input
                  type="date"
                  class="form-control"
                  name="Date"
                  #Date="ngModel"
                  [(ngModel)]="contacthistory.fecha"
                />
              </div>
              <div class="form-group">
                <label class="bmd-label-floating">Reminder Hour</label>
                <input
                  type="time"
                  class="form-control"
                  min="00:00:00"
                  max="23:59:00"
                  name="hora"
                  #hora="ngModel"
                  [(ngModel)]="contacthistory.hora"
                />
              </div>

              <div class="form-group">
                <label class="bmd-label-floating">Type of Reminder?</label>
                <br />
                <div>
                  <mat-checkbox
                    class="check-margin"
                    name="email"
                    [(ngModel)]="contacthistory.email"
                  >
                    Email
                  </mat-checkbox>
                  <mat-checkbox
                    style="margin-left: 20px"
                    class="check-margin"
                    name="notification"
                    [(ngModel)]="contacthistory.notification"
                  >
                    Notification
                  </mat-checkbox>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Things to remember</label>
              <div class="form-group">
                <textarea
                  name="descripcion"
                  #descripcion="ngModel"
                  [(ngModel)]="contacthistory.descripcion"
                  class="form-control"
                  rows="2"
                ></textarea>
              </div>
            </div>

            <div *ngIf="editHistory" class="">
              <div class="" style="text-align: right">
                <button class="btn btn-danger" (click)="cleanContact()">
                  <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back
                </button>
                &nbsp;
                <button
                  class="btn btn-primary"
                  [disabled]="saveEditHistory"
                  (click)="editContactHistory()"
                >
                  <i
                    *ngIf="saveEditHistory"
                    class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
                  ></i>
                  <i
                    *ngIf="!saveEditHistory"
                    class="fa fa-floppy-o"
                    aria-hidden="true"
                  ></i>
                  &nbsp; Save
                </button>
              </div>
            </div>
          </div>

          <div class="">
            <div class="">
              <div class="">
                <div class="d-flex">
                  <p class="mr-4">Add People To Reminder</p>
                  <label class="switch">
                    <input
                      type="checkbox"
                      [checked]="enableUsers"
                      (change)="enableUsers = !enableUsers"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="">
                  <div *ngIf="enableUsers">
                    <h4>Enable Users</h4>
                    <form>
                      <div>
                        <mat-form-field class="example-full-width">
                          <mat-label>Search</mat-label>
                          <input
                            matInput
                            [formControl]="myControlUsers"
                            placeholder="Search"
                            type="text"
                          />
                        </mat-form-field>
                      </div>
                    </form>
                  </div>

                  <div class="" *ngIf="enableUsers">
                    <div class="">
                      <section class="scroll">
                        <div
                          *ngFor="let item of filteredArrayUsers | async"
                          class="notify"
                        >
                          <div class="">
                            <div class="" (click)="seleccionarUser(item.id)">
                              <div class="">
                                <a
                                  class="btn btn-link btn-primary btn-just-icon"
                                >
                                  <i class="material-icons">{{
                                    chequeadoUser(item.id)
                                      ? "check_box"
                                      : "check_box_outline_blank"
                                  }}</i>
                                </a>
                                <span
                                  >{{ item.name | titlecase }}
                                  {{ item.surname }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div mat-dialog-actions *ngIf="!editHistory">
            <button
              *ngIf="item !== undefined"
              type="submit"
              (click)="onSubmitReminder()"
              [disabled]="!contacthistory.email && !contacthistory.notification"
              style="margin-left: 10px"
              class="btn btn-success"
            >
              Save Reminder
            </button>
          </div>

          <div
            *ngIf="!editHistory && item !== undefined"
            class=""
            style="margin-top: 30px"
          >
            <h3>Reminder History</h3>
            <hr />
            <br />

            <dinamic-table
              *ngIf="!loadingR"
              [id]="'remindersTable'"
              [frontpaginate]="true"
              [data]="reminders"
              [sort]="[[2, 'desc']]"
              (action_button)="actionR($event)"
            ></dinamic-table>

            <br /><br />
          </div>
        </div>
        <div
          *ngIf="
            tab == 1 &&
            !newManifest &&
            !newManifest2 &&
            !splitManifest &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
        >
          <div class="" *ngIf="action != 'read' && item.po.id == null">
            <!-- <div class="">
                                        <mat-form-field style="margin-top: 30px;">
                                            <mat-label>PO#</mat-label>
                                            <mat-select name="po" id="po" #po="ngModel" [(ngModel)]="item.po.id" required>
                                                <mat-option value=null disabled>Please select an option</mat-option>
                                                <mat-option *ngFor="let po of poList" [value]="po.id">{{po.po}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>-->
            <div *ngIf="createPO" class="">
              <div class="form-group">
                <mat-form-field class="example-full-width">
                  <mat-label>Client Name or Company Name</mat-label>
                  <input
                    type="text"
                    [(ngModel)]="clientSelected"
                    placeholder="Client Name or Company Name"
                    aria-label="Client Name or Company Name"
                    matInput
                    [formControl]="myControlClientes2"
                    [matAutocomplete]="autoClientes"
                    id="clienteSP1"
                    required
                  />
                  <mat-autocomplete
                    (optionSelected)="selectClient($event.option)"
                    #autoClientes="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    <mat-option
                      *ngFor="let option of filteredClientes2 | async"
                      [value]="option"
                    >
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="!createPO" class="">
              <mat-form-field class="example-full-width">
                <mat-label>Please select PO</mat-label>
                <input
                  type="text"
                  [(ngModel)]="pobuscador"
                  placeholder="Please select PO"
                  aria-label="Please select PO"
                  matInput
                  [formControl]="myControlClientes"
                  [matAutocomplete]="autoClientes"
                  id="nameCliente"
                  d
                  required
                />
                <mat-autocomplete
                  (optionSelected)="OnHumanSelected($event.option)"
                  #autoClientes="matAutocomplete"
                  [displayWith]="displayFn"
                >
                  <mat-option
                    *ngFor="let option of filteredClientes | async"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div
              *ngIf="companyLinked.id != 3 && !createPO"
              (click)="nuevaPO()"
              class="col-2"
            >
              <button class="btn btn-default">
                <i
                  *ngIf="syncpos"
                  class="fa fa-spinner fa-pulse fa-3x fa-fw"
                ></i>
                Create PO
              </button>
            </div>
            <div *ngIf="companyLinked.id == 3 && !createPO" class="col-2">
              <button
                class="btn btn-success"
                (click)="sync()"
                style="margin-top: 30px"
              >
                <i
                  *ngIf="syncpos"
                  class="fa fa-spinner fa-pulse fa-3x fa-fw"
                ></i>
                SYNC
              </button>
            </div>
          </div>
          <div class="grid-container" *ngIf="item.po.id != null">
            <mat-form-field appearance="fill" class="mr-4 mt-2">
              <mat-label>Purchasing Rep</mat-label>
              <select
                [(ngModel)]="item.buyer.id"
                required
                name="buyer"
                placeholder="Purchasing Rep"
                matNativeControl
                [disabled]="action == 'read' && !editar"
              >
                <option value="null" disabled>Select Purchasing Rep</option>
                <option *ngFor="let rep of repsList" [value]="rep.id">
                  {{ rep.name }} {{ rep.surname }}
                </option>
              </select>
            </mat-form-field>
            <div class="readonly-wrapper mt-4">
              <span class="readonly-label">Purchase Date</span>
              <span class="readonly-text">{{ poCreatedAt }}</span>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mr-4">
                <mat-label>Purchasing Terms</mat-label>
                <select
                  [(ngModel)]="selectedTerm"
                  (ngModelChange)="selectTerms($event)"
                  required
                  name="net_terms"
                  placeholder="Purchasing Terms"
                  matNativeControl
                  [disabled]="action === 'read' && !editar"
                >
                  <option value="" disabled>Select Purchasing Terms</option>
                  <option *ngFor="let term of netTerms" [ngValue]="term">
                    {{ term.name }}
                  </option>
                </select>
              </mat-form-field>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="d-flex w-100"
                *ngIf="
                  action != 'read' ||
                  identity.role === 'ADMINISTRATOR' ||
                  identity.role === 'PURCHASINGREP' ||
                  identity.role === 'SALESREP' ||
                  identity.role === 'MANAGER'
                "
              >
                <span class="pr-2" *ngIf="isRevenue == 0">$</span>
                <span class="pr-2" *ngIf="isRevenue == 1">%</span>
                <mat-form-field
                  *ngIf="
                    action != 'read' ||
                    identity.role === 'ADMINISTRATOR' ||
                    identity.role === 'PURCHASINGREP' ||
                    identity.role === 'SALESREP' ||
                    identity.role === 'MANAGER'
                  "
                  class="example-full-width"
                >
                  <mat-label>Original Total Cost of the PO</mat-label>

                  <input
                    type="number"
                    min="0.01"
                    step="0.01"
                    id="original_total_cost_po"
                    name="original_total_cost_po"
                    [(ngModel)]="item.originalTotalCostPo"
                    matInput
                    placeholder="Original Total Cost of the PO"
                    required
                    [disabled]="action == 'read' && !editar"
                  />
                </mat-form-field>
              </div>
            </div>
            <mat-form-field class="example-full-width">
              <mat-label>Reference</mat-label>

              <input
                placeholder="Reference"
                type="text"
                id="reference"
                name="reference"
                [(ngModel)]="item.reference"
                matInput
                disabled
              />
            </mat-form-field>
            <div class="readonly-wrapper mt-4">
              <span class="readonly-label">Date Received</span>
              <span class="readonly-text">{{ dateReceived }}</span>
            </div>
            <mat-form-field appearance="fill">
              <mat-label>Has the equipment been sold?</mat-label>
              <select
                [(ngModel)]="item.hasTheEquipmentBeenSold"
                name="hasTheEquipmentBeenSold"
                matNativeControl
                required
                name="hasTheEquipmentBeenSold"
                id="hasTheEquipmentBeenSold"
                (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="yesAll">Yes – All</option>
                <option value="yesParcial">Yes – Partial</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <mat-form-field class="" appearance="fill">
              <mat-label>Warranty</mat-label>
              <select
                name="warranty"
                [(ngModel)]="item.warranty"
                placeholder="Warranty"
                required
                matNativeControl
                [disabled]="action == 'read' && !editar"
              >
                <option value="" disabled>Select Warranty</option>
                <option value="ASIS">AS-IS</option>
                <option value="1DAY">1 Day</option>
                <option value="5DAYS">5 Days</option>
                <option value="15DAYS">15 Days</option>
                <option value="30DAYS">30 Days</option>
                <option value="60DAYS">60 Days</option>
                <option value="6MONTHS">6 Months</option>
                <option value="1YEAR">1 Year</option>
              </select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="mr-4">
              <mat-label>Manifest Required?</mat-label>
              <select
                name="manifestRequired"
                id="manifestRequired"
                matNativeControl
                [(ngModel)]="item.manifestRequired"
                [disabled]="
                  step !== 'INTRANSIT' ||
                  (action == 'read' && !editar) ||
                  !!customerSignature ||
                  !!agentSignature
                "
                required
              >
                <option value="null" disabled>Please select an option</option>
                <option value="yesDetailedManifest">
                  Yes - Detailed Manifest
                </option>
                <option value="noReportingRequired">
                  No – No Reporting Required
                </option>
                <option value="noCertificateDisposalOnly">
                  No – Certificate of Disposal Only
                </option>
              </select>
            </mat-form-field>

            <div
              *ngIf="
                item.manifestRequired == 'noReportingRequired' ||
                item.manifestRequired == 'noCertificateDisposalOnly' ||
                item.manifestRequired == 'No'
              "
              class=""
            >
              <mat-form-field appearance="fill" class="mr-4">
                <mat-label>No Manifest Priority Level</mat-label>
                <select
                  name="no_manifest_priority_level"
                  [(ngModel)]="item.no_manifest_priority_level"
                  placeholder="No Manifest Priority Level"
                  matNativeControl
                  [disabled]="action == 'read' && !editar"
                  required
                  [disabled]="action == 'read' && !editar"
                >
                  <option value="null" disabled>Select Priority</option>
                  <option value="No Manifest - 30 Days">
                    No Manifest - 30 Days
                  </option>
                  <option value="No Manifest - 15 Days">
                    No Manifest - 15 Days
                  </option>
                  <option value="No Manifest - 7 Days">
                    No Manifest - 7 Days
                  </option>
                  <option value="No Manifest - 1 Day">
                    No Manifest - 1 Day
                  </option>
                </select>
              </mat-form-field>
            </div>
            <mat-form-field
              *ngIf="
                item.manifestRequired == 'Yes' ||
                item.manifestRequired == 'yesDetailedManifest'
              "
              appearance="fill"
            >
              <mat-label>Manifest Priority Level </mat-label>
              <select
                [(ngModel)]="item.manifest_priority_level"
                name="manifest_priority_level"
                matNativeControl
                required
                name="manifest_priority_level"
                id="manifest_priority_level"
                (ngModelChange)="selectChange('manifest_priority_level')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="" disabled>Select Priority</option>
                <!--<option value="NOMANIFEST">No Manifest</option>-->
                <option value="LOWPRIORITY">Low Priority - 30 Days</option>
                <option value="MEDIUMPRIORITY">
                  Medium Priority - 15 Days
                </option>
                <option value="FASTPRIORITY">Fast Priority - 7 Days</option>
                <option value="URGENTPRIORITY">Urgent Same Day - 1 Day</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label for="dataDestructionRequired"
                >Data Destruction Required?</mat-label
              >
              <select
                name="dataDestructionRequired"
                matNativeControl
                id="dataDestructionRequired"
                [(ngModel)]="item.dataDestructionRequired"
                [disabled]="action == 'read' && !editar"
                required
              >
                <option value="null" disabled>Please select an option</option>
                <option value="yesDataDestruction">
                  Yes – Data Destruction
                </option>
                <option value="noDataDestruction">No – Data Destruction</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label for="esgReportingRequired"
                >ESG Reporting Required</mat-label
              >
              <select
                name="esgReportingRequired"
                id="esgReportingRequired"
                matNativeControl
                [(ngModel)]="item.esgReportingRequired"
                required
                [disabled]="action == 'read' && !editar"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label for="typeReport"
                >Physical Destruction Report</mat-label
              >
              <!-- (ngModelChange)="selectChange('typeReport')" -->
              <select
                name="typeReport"
                id="typeReport"
                [(ngModel)]="item.po.typeReport"
                required
                matNativeControl
                [disabled]="action == 'read' && !editar"
                (ngModelChange)="selectChange('typeReport')"
              >
                <option value="basic">Basic</option>
                <option value="detailed">Detailed</option>
              </select>
            </mat-form-field>
            <div class="readonly-wrapper mt-4">
              <span class="readonly-label">Status</span>
              <span *ngIf="singleStatus" class="readonly-text">{{
                step | Status
              }}</span>
              <div class="d-flex text-nowrap">
                <span
                  *ngIf="
                    itemsOnDepartament.numReceived > 0 ||
                    itemsOnDepartament.num_received_second > 0 ||
                    itemsOnDepartament.num_received_third > 0
                  "
                >
                  Received</span
                >
                <span
                  *ngIf="
                    itemsOnDepartament.numInmanifest > 0 ||
                    itemsOnDepartament.num_inmanifest_second > 0 ||
                    itemsOnDepartament.num_inmanifest_third > 0
                  "
                >
                  {{
                    itemsOnDepartament.numReceived > 0 ||
                    itemsOnDepartament.num_received_second > 0 ||
                    itemsOnDepartament.num_received_third > 0
                      ? "/"
                      : ""
                  }}
                  In Manifest</span
                >
                <span
                  *ngIf="
                    itemsOnDepartament.numIntesting > 0 ||
                    itemsOnDepartament.num_intesting_second > 0 ||
                    itemsOnDepartament.num_intesting_third > 0
                  "
                >
                  {{
                    itemsOnDepartament.numReceived > 0 ||
                    itemsOnDepartament.num_received_second > 0 ||
                    itemsOnDepartament.num_received_third > 0 ||
                    itemsOnDepartament.numInmanifest > 0 ||
                    itemsOnDepartament.num_inmanifest_second > 0 ||
                    itemsOnDepartament.num_inmanifest_third > 0
                      ? "/"
                      : ""
                  }}
                  In Testing
                </span>
                <span
                  *ngIf="
                    itemsOnDepartament.numInsales > 0 ||
                    itemsOnDepartament.num_insales_second > 0 ||
                    itemsOnDepartament.num_insales_third > 0
                  "
                >
                  {{
                    itemsOnDepartament.numReceived > 0 ||
                    itemsOnDepartament.num_received_second > 0 ||
                    itemsOnDepartament.num_received_third > 0 ||
                    itemsOnDepartament.numInmanifest > 0 ||
                    itemsOnDepartament.num_inmanifest_second > 0 ||
                    itemsOnDepartament.num_inmanifest_third > 0 ||
                    itemsOnDepartament.numIntesting > 0 ||
                    itemsOnDepartament.num_intesting_second > 0 ||
                    itemsOnDepartament.num_intesting_third > 0
                      ? "/"
                      : ""
                  }}
                  In Sales
                </span>
                <span
                  *ngIf="
                    itemsOnDepartament.num_processed > 0 ||
                    itemsOnDepartament.num_processed_second > 0 ||
                    itemsOnDepartament.num_processed_third > 0
                  "
                >
                  {{
                    itemsOnDepartament.numReceived > 0 ||
                    itemsOnDepartament.num_received_second > 0 ||
                    itemsOnDepartament.num_received_third > 0 ||
                    itemsOnDepartament.numInmanifest > 0 ||
                    itemsOnDepartament.num_inmanifest_second > 0 ||
                    itemsOnDepartament.num_inmanifest_third > 0 ||
                    itemsOnDepartament.numIntesting > 0 ||
                    itemsOnDepartament.num_intesting_second > 0 ||
                    itemsOnDepartament.num_intesting_third > 0 ||
                    itemsOnDepartament.numInsales > 0 ||
                    itemsOnDepartament.num_insales_second > 0 ||
                    itemsOnDepartament.num_insales_third > 0
                      ? "/"
                      : ""
                  }}
                  Processed
                </span>
              </div>
            </div>
            <mat-form-field class="example-full-width">
              <mat-label>Payment Status</mat-label>

              <input
                type="text"
                id="paymentStatus"
                name="paymentStatus"
                [(ngModel)]="paymentStatus"
                matInput
                placeholder="Payment Status"
                disabled
              />
            </mat-form-field>
            <mat-form-field class="example-full-width">
              <mat-label>Manifest Status</mat-label>

              <input
                type="text"
                id="manifestStatusForm"
                name="manifestStatusForm"
                [(ngModel)]="item.manifestStatus"
                placeholder="Manifest Status"
                matInput
                disabled
              />
            </mat-form-field>
            <div class="readonly-wrapper mt-4">
              <span class="readonly-label">Manifest Completed Date </span>
              <span class="readonly-text">{{ manifestCompletedDate }}</span>
            </div>
            <mat-form-field class="example-full-width">
              <mat-label>Testing Status</mat-label>

              <input
                placeholder="Testing Status"
                type="text"
                id="testingStatusForm"
                name="testingStatusForm"
                [(ngModel)]="testingStatusForm"
                matInput
                disabled
              />
            </mat-form-field>
            <div class="readonly-wrapper mt-4">
              <span class="readonly-label">Testing Completed Date</span>
              <span class="readonly-text">{{ testingCompletedDate }}</span>
            </div>

            <div class="readonly-wrapper mt-4">
              <span class="readonly-label">HDD Status</span>
              <span class="readonly-text">{{ batch }}</span>
            </div>
          </div>
          <div class="grid-container" *ngIf="item.po.id != null"></div>
          <div class="grid-container" *ngIf="item.po.id != null">
            <div *ngIf="sales != ''">
              <div class="form-group"></div>
            </div>
          </div>
        </div>
        <!-- --------------------------------------Seccion 2------------------------------------------ -->
        <div
          *ngIf="
            tab == 2 &&
            !newManifest &&
            !newManifest2 &&
            !splitManifest &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
        >
          <app-transportation-details
            [po_id]="item.po.id"
            [tableTrakings]="tableTrakings"
          >
          </app-transportation-details>
        </div>
        <!-- --------------------------------------Seccion 3------------------------------------------ -->
        <div
          *ngIf="
            tab == 3 &&
            !newManifest &&
            !newManifest2 &&
            !splitManifest &&
            deletManiest_id == null &&
            !erasure &&
            !changeStatus
          "
        >
          <div></div>
          <div class="grid-container">
            <mat-form-field appearance="fill" class="mr-4">
              <mat-label>Purchasing Rep</mat-label>
              <select
                [(ngModel)]="item.buyer.id"
                required
                name="buyer"
                placeholder="Purchasing Rep"
                matNativeControl
                [disabled]="action == 'read' && !editar"
              >
                <option value="null" disabled>Select Purchasing Rep</option>
                <option *ngFor="let rep of repsList" [value]="rep.id">
                  {{ rep.name }} {{ rep.surname }}
                </option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="mr-4">
              <mat-label>Manifest Required?</mat-label>
              <select
                name="manifestRequired"
                id="manifestRequired"
                matNativeControl
                [(ngModel)]="item.manifestRequired"
                [disabled]="
                  step !== 'INTRANSIT' ||
                  (action == 'read' && !editar) ||
                  !!customerSignature ||
                  !!agentSignature
                "
                required
              >
                <option value="null" disabled>Please select an option</option>
                <option value="yesDetailedManifest">
                  Yes - Detailed Manifest
                </option>
                <option value="noReportingRequired">
                  No – No Reporting Required
                </option>
                <option value="noCertificateDisposalOnly">
                  No – Certificate of Disposal Only
                </option>
              </select>
            </mat-form-field>
            <div
              *ngIf="
                item.manifestRequired == 'noReportingRequired' ||
                item.manifestRequired == 'noCertificateDisposalOnly' ||
                item.manifestRequired == 'No'
              "
              class=""
            >
              <mat-form-field appearance="fill" class="mr-4">
                <mat-label>No Manifest Priority Level</mat-label>
                <select
                  name="no_manifest_priority_level"
                  [(ngModel)]="item.no_manifest_priority_level"
                  placeholder="No Manifest Priority Level"
                  matNativeControl
                  [disabled]="action == 'read' && !editar"
                  required
                  [disabled]="action == 'read' && !editar"
                >
                  <option value="null" disabled>Select Priority</option>
                  <option value="No Manifest - 30 Days">
                    No Manifest - 30 Days
                  </option>
                  <option value="No Manifest - 15 Days">
                    No Manifest - 15 Days
                  </option>
                  <option value="No Manifest - 7 Days">
                    No Manifest - 7 Days
                  </option>
                  <option value="No Manifest - 1 Day">
                    No Manifest - 1 Day
                  </option>
                </select>
              </mat-form-field>
            </div>
            <mat-form-field
              *ngIf="
                item.manifestRequired == 'Yes' ||
                item.manifestRequired == 'yesDetailedManifest'
              "
              appearance="fill"
            >
              <mat-label>Manifest Priority Level </mat-label>
              <select
                [(ngModel)]="item.manifest_priority_level"
                name="manifest_priority_level"
                matNativeControl
                required
                name="manifest_priority_level"
                id="manifest_priority_level"
                (ngModelChange)="selectChange('manifest_priority_level')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="" disabled>Select Priority</option>
                <!--<option value="NOMANIFEST">No Manifest</option>-->
                <option value="LOWPRIORITY">Low Priority - 30 Days</option>
                <option value="MEDIUMPRIORITY">
                  Medium Priority - 15 Days
                </option>
                <option value="FASTPRIORITY">Fast Priority - 7 Days</option>
                <option value="URGENTPRIORITY">Urgent Same Day - 1 Day</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label for="dataDestructionRequired"
                >Data Destruction Required?</mat-label
              >
              <select
                name="dataDestructionRequired"
                matNativeControl
                id="dataDestructionRequired"
                [(ngModel)]="item.dataDestructionRequired"
                [disabled]="action == 'read' && !editar"
                required
              >
                <option value="null" disabled>Please select an option</option>
                <option value="yesDataDestruction">
                  Yes – Data Destruction
                </option>
                <option value="noDataDestruction">No – Data Destruction</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Physical Destruction of Equipment?</mat-label>
              <select
                [(ngModel)]="item.all_cod"
                name="all_cod"
                matNativeControl
                required
                name="all_cod"
                id="all_cod"
                (ngModelChange)="selectChange('all_cod')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="NREQU">Not Required</option>
                <option value="Yes">All the equipment</option>
                <option value="No">Some of the equipment</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Hard Drive Shredding?</mat-label>
              <select
                [(ngModel)]="item.hdShredding"
                name="hdShredding"
                matNativeControl
                required
                name="hdShredding"
                id="hdShredding"
                (ngModelChange)="selectChange('hdShredding')"
                [disabled]="action == 'read' && !editar"
              >
                <!-- <option value="null">Please select an option</option> -->
                <option value="NREQU">Not Required</option>
                <option value="Yes">Some Hard Drives</option>
                <option value="No">All the Hard Drives</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Sort Equipment</mat-label>
              <select
                [(ngModel)]="item.sortEquipment"
                name="sortEquipment"
                matNativeControl
                required
                name="sortEquipment"
                id="sortEquipment"
                (ngModelChange)="selectChange('sortEquipment')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Picture Required?</mat-label>
              <select
                [(ngModel)]="item.pictureRequired"
                name="pictureRequired"
                matNativeControl
                required
                name="pictureRequired"
                id="pictureRequired"
                (ngModelChange)="selectChange('pictureRequired')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Security Seal Picture Required?</mat-label>
              <select
                [(ngModel)]="item.securitySealPictureRequired"
                name="securitySealPictureRequired"
                matNativeControl
                required
                name="securitySealPictureRequired"
                id="securitySealPictureRequired"
                (ngModelChange)="selectChange('securitySealPictureRequired')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Has the equipment been sold?</mat-label>
              <select
                [(ngModel)]="item.hasTheEquipmentBeenSold"
                name="hasTheEquipmentBeenSold"
                matNativeControl
                required
                name="hasTheEquipmentBeenSold"
                id="hasTheEquipmentBeenSold"
                (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
                [disabled]="action == 'read' && !editar"
              >
                <option value="yesAll">Yes – All</option>
                <option value="yesParcial">Yes – Partial</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label for="sendStraightToTesting"
                >Send straight to testing?</mat-label
              >
              <select
                name="sendStraightToTesting"
                matNativeControl
                id="sendStraightToTesting"
                [(ngModel)]="item.sendStraightToTesting"
                [disabled]="action == 'read' && !editar"
                required
              >
                <option value="null" disabled>Please select an option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label for="warehouseLocation">Warehouse Location</mat-label>
              <input
                placeholder="Warehouse Location"
                type="text"
                id="warehouseLocation"
                name="warehouseLocation"
                [value]="warehouseLocation"
                matInput
                disabled
              />
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="notesForReceiving">Notes for receiving</label>
            <div class="form-group">
              <textarea
                name="notesForReceiving"
                #notesForReceiving="ngModel"
                [(ngModel)]="item.notesForReceiving"
                class="form-control"
                rows="5"
                [readonly]="action == 'read' && !editar"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- --------------------------------------Seccion 4------------------------------------------ -->
      <div
        *ngIf="
          tab == 4 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div class="grid-container">
          <mat-form-field appearance="fill">
            <mat-label>Purchasing Rep</mat-label>
            <select
              [(ngModel)]="item.buyer.id"
              required
              name="rep_id"
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option *ngFor="let rep of repsList" [value]="rep.id">
                {{ rep.name }} {{ rep.surname }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Manifest Rep</mat-label>

            <input
              placeholder="Manifest Rep"
              type="text"
              id="manifestRep"
              name="manifestRep"
              [(ngModel)]="manifest"
              matInput
              disabled
            />
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>Manifest Status</mat-label>

            <input
              type="text"
              id="manifestStatusForm"
              name="manifestStatusForm"
              [(ngModel)]="item.manifestStatus"
              placeholder="Manifest Status"
              matInput
              disabled
            />
          </mat-form-field>
          <div class="readonly-wrapper mt-4">
            <span class="readonly-label">Manifest Completed Date </span>
            <span class="readonly-text">{{ manifestCompletedDate }}</span>
          </div>
          <mat-form-field appearance="fill" class="mr-4">
            <mat-label>Manifest Required?</mat-label>
            <select
              name="manifestRequired"
              id="manifestRequired"
              matNativeControl
              [(ngModel)]="item.manifestRequired"
              [disabled]="
                step !== 'INTRANSIT' ||
                (action == 'read' && !editar) ||
                !!customerSignature ||
                !!agentSignature
              "
              required
            >
              <option value="null" disabled>Please select an option</option>
              <option value="yesDetailedManifest">
                Yes - Detailed Manifest
              </option>
              <option value="noReportingRequired">
                No – No Reporting Required
              </option>
              <option value="noCertificateDisposalOnly">
                No – Certificate of Disposal Only
              </option>
            </select>
          </mat-form-field>
          <div
            *ngIf="
              item.manifestRequired == 'noReportingRequired' ||
              item.manifestRequired == 'noCertificateDisposalOnly' ||
              item.manifestRequired == 'No'
            "
            class=""
          >
            <mat-form-field appearance="fill" class="mr-4">
              <mat-label>No Manifest Priority Level</mat-label>
              <select
                name="no_manifest_priority_level"
                [(ngModel)]="item.no_manifest_priority_level"
                placeholder="No Manifest Priority Level"
                matNativeControl
                [disabled]="action == 'read' && !editar"
                required
                [disabled]="action == 'read' && !editar"
              >
                <option value="null" disabled>Select Priority</option>
                <option value="No Manifest - 30 Days">
                  No Manifest - 30 Days
                </option>
                <option value="No Manifest - 15 Days">
                  No Manifest - 15 Days
                </option>
                <option value="No Manifest - 7 Days">
                  No Manifest - 7 Days
                </option>
                <option value="No Manifest - 1 Day">No Manifest - 1 Day</option>
              </select>
            </mat-form-field>
          </div>
          <mat-form-field
            *ngIf="
              item.manifestRequired == 'Yes' ||
              item.manifestRequired == 'yesDetailedManifest'
            "
            appearance="fill"
          >
            <mat-label>Manifest Priority Level </mat-label>
            <select
              [(ngModel)]="item.manifest_priority_level"
              name="manifest_priority_level"
              matNativeControl
              required
              name="manifest_priority_level"
              id="manifest_priority_level"
              (ngModelChange)="selectChange('manifest_priority_level')"
              [disabled]="action == 'read' && !editar"
            >
              <option value="" disabled>Select Priority</option>
              <!--<option value="NOMANIFEST">No Manifest</option>-->
              <option value="LOWPRIORITY">Low Priority - 30 Days</option>
              <option value="MEDIUMPRIORITY">Medium Priority - 15 Days</option>
              <option value="FASTPRIORITY">Fast Priority - 7 Days</option>
              <option value="URGENTPRIORITY">Urgent Same Day - 1 Day</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label for="dataDestructionRequired"
              >Data Destruction Required?</mat-label
            >
            <select
              name="dataDestructionRequired"
              matNativeControl
              id="dataDestructionRequired"
              [(ngModel)]="item.dataDestructionRequired"
              required
              [disabled]="action == 'read' && !editar"
            >
              <option value="null" disabled>Please select an option</option>
              <option value="yesDataDestruction">Yes – Data Destruction</option>
              <option value="noDataDestruction">No – Data Destruction</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Pull Hard Drives?</mat-label>
            <select
              [(ngModel)]="item.pullHardDrives"
              name="pullHardDrives"
              matNativeControl
              required
              name="pullHardDrives"
              id="pullHardDrives"
              (ngModelChange)="selectChange('pullHardDrives')"
              [disabled]="action == 'read' && !editar"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hard Drive Shredding?</mat-label>
            <select
              [(ngModel)]="item.hdShredding"
              name="hdShredding"
              matNativeControl
              required
              name="hdShredding"
              id="hdShredding"
              (ngModelChange)="selectChange('hdShredding')"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="null">Please select an option</option> -->
              <option value="NREQU">Not Required</option>
              <option value="Yes">Some Hard Drives</option>
              <option value="No">All the Hard Drives</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label for="typeReport">Physical Destruction Report</mat-label>
            <!-- (ngModelChange)="selectChange('typeReport')" -->
            <select
              name="typeReport"
              id="typeReport"
              [(ngModel)]="item.typeReport"
              required
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="basic">Basic</option>
              <option value="detailed">Detailed</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hold Equipment?</mat-label>
            <select
              [(ngModel)]="item.holdDefectiveEquipment"
              name="hold_defective_equipment"
              matNativeControl
              required
              name="hold_defective_equipment"
              id="hold_defective_equipment"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="nothin">Nothing</option>
              <option value="defec">Defective Equipment Only</option>
              <option value="every">Everything</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Has the equipment been sold?</mat-label>
            <select
              [(ngModel)]="item.hasTheEquipmentBeenSold"
              name="hasTheEquipmentBeenSold"
              matNativeControl
              required
              name="hasTheEquipmentBeenSold"
              id="hasTheEquipmentBeenSold"
              (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
              [disabled]="action == 'read' && !editar"
            >
              <option value="yesAll">Yes – All</option>
              <option value="yesParcial">Yes – Partial</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Testing Report Required</mat-label>
            <select
              (ngModelChange)="selectChange('testingReportRequired')"
              [(ngModel)]="item.testingReportRequired"
              name="testingReportRequired"
              matNativeControl
              required
              name="testingReportRequired"
              id="testingReportRequired"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label class="bmd-label-floating" for="notesForManifest"
            >Notes for Manifest
          </label>
          <div class="form-group">
            <textarea
              name="notesForManifest"
              #notesForManifest="ngModel"
              [(ngModel)]="item.notesForManifest"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- --------------------------------------Seccion 5 ------------------------------------------ -->
      <div
        *ngIf="
          tab == 5 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div class="grid-container">
          <mat-form-field class="example-full-width">
            <mat-label>Testing Rep</mat-label>

            <input
              type="text"
              [(ngModel)]="tech"
              name="tech"
              readonly
              matInput
              placeholder="Testing Rep"
              disabled
            />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Purchasing Rep</mat-label>
            <select
              [(ngModel)]="item.buyer.id"
              required
              name="rep_id"
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option *ngFor="let rep of repsList" [value]="rep.id">
                {{ rep.name }} {{ rep.surname }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="mr-4">
            <mat-label>Purchasing Terms</mat-label>
            <select
              [(ngModel)]="selectedTerm"
              (ngModelChange)="selectTerms(selectedTerm, $event)"
              required
              name="net_terms"
              placeholder="Purchasing Terms"
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="" disabled>Select Purchasing Terms</option>
              <option *ngFor="let term of netTerms" [ngValue]="term">
                {{ term.name }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Warranty</mat-label>
            <select
              name="warranty"
              [(ngModel)]="item.warranty"
              placeholder="Warranty"
              required
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="" disabled>Select Warranty</option>
              <option value="ASIS">AS-IS</option>
              <option value="1DAY">1 Day</option>
              <option value="5DAYS">5 Days</option>
              <option value="15DAYS">15 Days</option>
              <option value="30DAYS">30 Days</option>
              <option value="60DAYS">60 Days</option>
              <option value="6MONTHS">6 Months</option>
              <option value="1YEAR">1 Year</option>
            </select>
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Testing Status</mat-label>

            <input
              placeholder="Testing Status"
              type="text"
              id="testingStatusForm"
              name="testingStatusForm"
              [(ngModel)]="testingStatusForm"
              matInput
              disabled
            />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Has the equipment been sold?</mat-label>
            <select
              [(ngModel)]="item.hasTheEquipmentBeenSold"
              name="hasTheEquipmentBeenSold"
              matNativeControl
              required
              name="hasTheEquipmentBeenSold"
              id="hasTheEquipmentBeenSold"
              (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
              [disabled]="action == 'read' && !editar"
            >
              <option value="yesAll">Yes – All</option>
              <option value="yesParcial">Yes – Partial</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Testing Report Required</mat-label>
            <select
              (ngModelChange)="selectChange('testingReportRequired')"
              [(ngModel)]="item.testingReportRequired"
              name="testingReportRequired"
              matNativeControl
              required
              name="testingReportRequired"
              id="testingReportRequired"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Testing Priority Level</mat-label>
            <select
              [(ngModel)]="item.poPriorityLevel"
              name="po_priority_level"
              matNativeControl
              required
              name="po_priority_level"
              id="po_priority_level"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="null" disabled>Select Priority</option>
              <option value="LOWPRIORITY">Low Priority</option>
              <option value="MEDIUMPRIORITY">Medium Priority</option>
              <option value="FASTPRIORITY">Fast Priority</option>
              <option value="URGENTPRIORITY">Urgent Same Day</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Data Destruction Required?</mat-label>
            <select
              [(ngModel)]="item.dataDestructionRequired"
              name="dataDestructionRequired"
              matNativeControl
              required
              name="dataDestructionRequired"
              id="dataDestructionRequired"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="null" disabled>Please select an option</option>
              <option value="yesDataDestruction">Yes – Data Destruction</option>
              <option value="noDataDestruction">No – Data Destruction</option>
            </select>
          </mat-form-field>
          <mat-form-field class="" appearance="fill">
            <mat-label>Erasure Method</mat-label>
            <select
              (ngModelChange)="selectChange('passDataErasure1')"
              [(ngModel)]="item.passDataErasure1"
              name="passDataErasure1"
              matNativeControl
              required
              name="passDataErasure1"
              id="passDataErasure1"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option *ngFor="let item of erasureMethods" [value]="item.name">
                {{ item.name }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hold Bad Hard Drives?</mat-label>
            <select
              (ngModelChange)="selectChange('holdBadHardDrives')"
              [(ngModel)]="item.holdBadHardDrives"
              name="holdBadHardDrives"
              matNativeControl
              required
              name="holdBadHardDrives"
              id="holdBadHardDrives"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hold Equipment?</mat-label>
            <select
              [(ngModel)]="item.holdDefectiveEquipment"
              name="hold_defective_equipment"
              matNativeControl
              required
              name="hold_defective_equipment"
              id="hold_defective_equipment"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="nothin">Nothing</option>
              <option value="defec">Defective Equipment Only</option>
              <option value="every">Everything</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Sort and Settle?</mat-label>
            <select
              [(ngModel)]="item.sortAndSettle"
              name="sort_and_settle"
              matNativeControl
              required
              name="sort_and_settle"
              id="sort_and_settle"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Breakdown Available</mat-label>
            <select
              name="inventory_manifest"
              id="inventory_manifest"
              [(ngModel)]="item.inventoryManifest"
              name="inventory_manifest"
              matNativeControl
              required
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="yNote">Yes, inside notes.</option>
              <option value="yFile">Yes, inside files.</option>
              <option value="nBrea">No breakdown.</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label for="typeReport">Physical Destruction Report</mat-label>
            <!-- (ngModelChange)="selectChange('typeReport')" -->
            <select
              name="typeReport"
              id="typeReport"
              [(ngModel)]="item.typeReport"
              required
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="basic">Basic</option>
              <option value="detailed">Detailed</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label for="sendStraightToTesting"
              >Send straight to testing?</mat-label
            >
            <select
              name="sendStraightToTesting"
              matNativeControl
              id="sendStraightToTesting"
              [(ngModel)]="item.sendStraightToTesting"
              [disabled]="action == 'read' && !editar"
              required
            >
              <option value="null" disabled>Please select an option</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <div class="readonly-wrapper mt-4">
            <span class="readonly-label">Testing Completed Date</span>
            <span class="readonly-text">{{ testingCompletedDate }}</span>
          </div>
        </div>
        <div class="form-group">
          <label class="bmd-label-floating">Notes for Techs:</label>
          <div class="form-group">
            <textarea
              name="description_techs"
              #description_techs="ngModel"
              [(ngModel)]="item.description_techs"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- --------------------------------------Seccion 6 ------------------------------------------ -->
      <div
        *ngIf="
          tab == 6 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div class="grid-container">
          <mat-form-field appearance="fill">
            <mat-label>Purchasing Rep</mat-label>
            <select
              [(ngModel)]="item.buyer.id"
              required
              name="rep_id"
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option *ngFor="let rep of repsList" [value]="rep.id">
                {{ rep.name }} {{ rep.surname }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field class="" appearance="fill">
            <mat-label>Warranty</mat-label>
            <select
              name="warranty"
              [(ngModel)]="item.warranty"
              placeholder="Warranty"
              required
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="" disabled>Select Warranty</option>
              <option value="ASIS">AS-IS</option>
              <option value="1DAY">1 Day</option>
              <option value="5DAYS">5 Days</option>
              <option value="15DAYS">15 Days</option>
              <option value="30DAYS">30 Days</option>
              <option value="60DAYS">60 Days</option>
              <option value="6MONTHS">6 Months</option>
              <option value="1YEAR">1 Year</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Data Destruction Required?</mat-label>
            <select
              [(ngModel)]="item.dataDestructionRequired"
              name="dataDestructionRequired"
              matNativeControl
              required
              name="dataDestructionRequired"
              id="dataDestructionRequired"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="null" disabled>Please select an option</option>
              <option value="yesDataDestruction">Yes – Data Destruction</option>
              <option value="noDataDestruction">No – Data Destruction</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hard Drive Shredding?</mat-label>
            <select
              [(ngModel)]="item.hdShredding"
              name="hdShredding"
              matNativeControl
              required
              name="hdShredding"
              id="hdShredding"
              (ngModelChange)="selectChange('hdShredding')"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="null">Please select an option</option> -->
              <option value="NREQU">Not Required</option>
              <option value="Yes">Some Hard Drives</option>
              <option value="No">All the Hard Drives</option>
            </select>
          </mat-form-field>
          <mat-form-field class="" appearance="fill">
            <mat-label>Erasure Method</mat-label>
            <select
              (ngModelChange)="selectChange('passDataErasure1')"
              [(ngModel)]="item.passDataErasure1"
              name="passDataErasure1"
              matNativeControl
              required
              name="passDataErasure1"
              id="passDataErasure1"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option *ngFor="let item of erasureMethods" [value]="item.name">
                {{ item.name }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hold Bad Hard Drives?</mat-label>
            <select
              (ngModelChange)="selectChange('holdBadHardDrives')"
              [(ngModel)]="item.holdBadHardDrives"
              name="holdBadHardDrives"
              matNativeControl
              required
              name="holdBadHardDrives"
              id="holdBadHardDrives"
              [disabled]="action == 'read' && !editar"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label for="typeReport">Physical Destruction Report</mat-label>
            <!-- (ngModelChange)="selectChange('typeReport')" -->
            <select
              name="typeReport"
              id="typeReport"
              [(ngModel)]="item.typeReport"
              required
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="basic">Basic</option>
              <option value="detailed">Detailed</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Has the equipment been sold?</mat-label>
            <select
              [(ngModel)]="item.hasTheEquipmentBeenSold"
              name="hasTheEquipmentBeenSold"
              matNativeControl
              required
              name="hasTheEquipmentBeenSold"
              id="hasTheEquipmentBeenSold"
              (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
              [disabled]="action == 'read' && !editar"
            >
              <option value="yesAll">Yes – All</option>
              <option value="yesParcial">Yes – Partial</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <div class="readonly-wrapper">
            <span class="readonly-label">HDD Status</span>
            <span class="readonly-text">{{ batch }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="notesForWiping" class="bmd-label-floating"
            >Notes for Data Sanitization</label
          >
          <div class="form-group">
            <textarea
              name="notesForWiping"
              #notesForWiping="ngModel"
              [(ngModel)]="item.notesForWiping"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- --------------------------------------Seccion 7 ------------------------------------------ -->
      <div
        *ngIf="
          tab == 7 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div class="grid-container">
          <mat-form-field appearance="fill" class="mr-4">
            <mat-label>Purchasing Rep</mat-label>
            <select
              [(ngModel)]="item.buyer.id"
              required
              name="buyer"
              placeholder="Purchasing Rep"
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="null" disabled>Select Purchasing Rep</option>
              <option *ngFor="let rep of repsList" [value]="rep.id">
                {{ rep.name }} {{ rep.surname }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Sales Rep</mat-label>

            <input
              type="text"
              placeholder="Sales Rep"
              id="sls"
              name="sls"
              [(ngModel)]="sales"
              matInput
              disabled
            />
          </mat-form-field>
          <mat-form-field class="" appearance="fill">
            <mat-label>Warranty</mat-label>
            <select
              name="warranty"
              [(ngModel)]="item.warranty"
              placeholder="Warranty"
              required
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="" disabled>Select Warranty</option>
              <option value="ASIS">AS-IS</option>
              <option value="1DAY">1 Day</option>
              <option value="5DAYS">5 Days</option>
              <option value="15DAYS">15 Days</option>
              <option value="30DAYS">30 Days</option>
              <option value="60DAYS">60 Days</option>
              <option value="6MONTHS">6 Months</option>
              <option value="1YEAR">1 Year</option>
            </select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="mr-4">
            <mat-label>Purchasing Terms</mat-label>
            <select
              [(ngModel)]="selectedTerm"
              (ngModelChange)="selectTerms(selectedTerm, $event)"
              required
              name="net_terms"
              placeholder="Purchasing Terms"
              matNativeControl
              [disabled]="action == 'read' && !editar"
            >
              <option value="" disabled>Select Purchasing Terms</option>
              <option *ngFor="let term of netTerms" [ngValue]="term">
                {{ term.name }}
              </option>
            </select>
          </mat-form-field>
          <div class="d-flex align-items-center">
            <div
              class="d-flex w-100"
              *ngIf="
                action != 'read' ||
                identity.role === 'ADMINISTRATOR' ||
                identity.role === 'PURCHASINGREP' ||
                identity.role === 'SALESREP' ||
                identity.role === 'MANAGER'
              "
            >
              <span class="pr-2" *ngIf="isRevenue == 0">$</span>
              <span class="pr-2" *ngIf="isRevenue == 1">%</span>
              <mat-form-field
                *ngIf="
                  action != 'read' ||
                  identity.role === 'ADMINISTRATOR' ||
                  identity.role === 'PURCHASINGREP' ||
                  identity.role === 'SALESREP' ||
                  identity.role === 'MANAGER'
                "
                class="example-full-width"
              >
                <mat-label>Original Total Cost of the PO</mat-label>

                <input
                  type="number"
                  min="0.01"
                  step="0.01"
                  id="original_total_cost_po"
                  name="original_total_cost_po"
                  [(ngModel)]="item.originalTotalCostPo"
                  matInput
                  placeholder="Original Total Cost of the PO"
                  required
                  [disabled]="action == 'read' && !editar"
                />
              </mat-form-field>
            </div>
          </div>
          <mat-form-field class="example-full-width">
            <mat-label>Payment Status</mat-label>

            <input
              type="text"
              id="paymentStatus"
              name="paymentStatus"
              [(ngModel)]="paymentStatus"
              matInput
              placeholder="Payment Status"
              disabled
            />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Has the equipment been sold?</mat-label>
            <select
              [(ngModel)]="item.hasTheEquipmentBeenSold"
              name="hasTheEquipmentBeenSold"
              matNativeControl
              required
              name="hasTheEquipmentBeenSold"
              id="hasTheEquipmentBeenSold"
              (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
              [disabled]="action == 'read' && !editar"
            >
              <option value="yesAll">Yes – All</option>
              <option value="yesParcial">Yes – Partial</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label class="bmd-label-floating">Notes for Sales</label>
          <div class="form-group">
            <textarea
              name="notesForSales"
              #notesForSales="ngModel"
              [(ngModel)]="item.notesForSales"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- --------------------------------------Seccion 8------------------------------------------ -->
      <div
        *ngIf="
          tab == 8 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div *ngIf="itemShow">
          <div class="">
            <h3>You are editing container ID: {{ itemEditar }}</h3>
          </div>
          <hr />
        </div>
        <div *ngIf="recived != '1' || itemShow">
          <div class="row">
            <!--<div class="d-flex">
              <mat-form-field appearance="fill" class="mr-2">
                <div class="d-flex flex-column">
                  <mat-label>Warehouse Location</mat-label>
                </div>
                <select
                  [disabled]="!warehouseActivate"
                  name="whs"
                  [(ngModel)]="whs_id"
                  [disabled]="itemShow"
                  (change)="changeWarehouse()"
                  matNativeControl
                  [disabled]="action == 'read' && !editar"
                >
                  <option value="null" disabled>Please select an option</option>
                  <option *ngFor="let loc of warehouseList" [value]="loc.id">
                    {{ loc.name }}
                  </option>
                </select>
              </mat-form-field>
              <i
                *ngIf="changeWarehouseLocation"
                (click)="changeWHouseStatus()"
                class="material-icons ml-2 action-info"
              >
                edit
              </i>
            </div>-->
            <div class="col-md-3">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>*Warehouse Location</mat-label>

                <mat-select
                  [(value)]="whs_id"
                  [disabled]="!warehouseActivate"
                  (selectionChange)="changeWarehouse()"
                >
                  <mat-option value="null" disabled>Please select an option</mat-option>
                  <mat-option *ngFor="let loc of warehouseList" [value]="loc.id">
                    {{ loc.name }}
                  </mat-option>
                </mat-select>

                <button
                  mat-icon-button
                  matSuffix
                  class="lock-icon-btn"
                  tabindex="-1"
                  (click)="toggleWarehouseActivate()"
                  [attr.aria-label]="warehouseActivate ? 'Lock' : 'Unlock'"
                >
                  <mat-icon class="lock-icon">{{ warehouseActivate ? 'lock_open' : 'lock' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!--<div *ngIf="itemShow">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>Stage</mat-label>
                <select
                  name="is_piForm"
                  [(ngModel)]="itemIsPi"
                  class="form-control"
                  required
                  matNativeControl
                  [disabled]="itemIsPi == 1"
                >
                  <option value="null" disabled>Please select an option</option>
                  <option value="1">1st</option>
                  <option value="0">2nd</option>
                  <option value="3">3rd</option>
                  <option value="4">4th</option>
                </select>
              </mat-form-field>
            </div>-->
            <div class="col-md-3">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>*Stage</mat-label>

                <mat-select
                  name="is_piForm"
                  [(ngModel)]="itemIsPi"
                  placeholder="Stage"
                  [disabled]="lockStage"
                >
                  <mat-option *ngFor="let stage of stages" [value]="stage.value">
                    {{ stage.viewValue }}
                  </mat-option>
                </mat-select>

                <button
                  mat-icon-button
                  matSuffix
                  class="lock-icon-btn"
                  tabindex="-1"
                  (click)="lockStage = !lockStage"
                  [attr.aria-label]="lockStage ? 'Locked' : 'Unlocked'"
                >
                  <mat-icon class="lock-icon">{{ lockStage ? 'lock' : 'lock_open' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>Item Type</mat-label>

                <mat-select
                  name="itemtypeForm"
                  [(ngModel)]="itemtype"
                  (selectionChange)="sumarPeso()"
                  [disabled]="lockitemtype"
                >
                  <mat-option value="" disabled>Please select an option</mat-option>
                  <mat-option value="Box">Box</mat-option>
                  <mat-option value="Gondola">Gondola</mat-option>
                  <mat-option value="Gaylord">Gaylord</mat-option>
                  <mat-option value="Pallet">Pallet</mat-option>
                  <mat-option value="H-Dolly">H-Dolly</mat-option>
                  <mat-option value="Rack">Rack</mat-option>
                  <mat-option value="Standalone">Standalone</mat-option>
                </mat-select>

                <button
                  mat-icon-button
                  matSuffix
                  class="lock-icon-btn"
                  tabindex="-1"
                  (click)="lockitemtype = !lockitemtype"
                  [attr.aria-label]="lockitemtype ? 'Locked' : 'Unlocked'"
                >
                  <mat-icon class="lock-icon">{{ lockitemtype ? 'lock' : 'lock_open' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>Damages</mat-label>
                <mat-select
                  name="damagesForm"
                  [(ngModel)]="damages"
                  [disabled]="lockdamage"
                  required
                >
                  <mat-option value="" disabled>Please select an option</mat-option>
                  <mat-option value="Yes">Yes</mat-option>
                  <mat-option value="No">No</mat-option>
                </mat-select>

                <!-- Candado dentro del mat-form-field -->
                <button
                  mat-icon-button
                  matSuffix
                  class="lock-icon-btn"
                  tabindex="-1"
                  (click)="lockdamage = !lockdamage"
                  [attr.aria-label]="lockdamage ? 'Locked' : 'Unlocked'"
                >
                  <mat-icon class="lock-icon">
                    {{ lockdamage ? 'lock' : 'lock_open' }}
                  </mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div *ngIf="recived != '1' || itemShow">
          
          <!--<div class="d-flex mt-2">
            <mat-form-field appearance="fill" class="mr-2">
              <mat-label>Item Type &nbsp; &nbsp; </mat-label>
              <select
                name="itemtypeForm"
                [(ngModel)]="itemtype"
                (ngModelChange)="sumarPeso()"
                matNativeControl
              >
                <option value="" disabled>Please select an option</option>
                <option value="Box">Box</option>
                <option value="Gondola">Gondola</option>
                <option value="Gaylord">Gaylord</option>
                <option value="Pallet">Pallet</option>
                <option value="H-Dolly">H-Dolly</option>
                <option value="Rack">Rack</option>
                <option value="Standalone">Standalone</option>
              </select>
            </mat-form-field>
            <i
              class="fa {{ lockitemtype ? 'fa-lock' : 'fa-unlock' }}"
              (click)="lockitemtype = !lockitemtype"
              style="cursor: pointer"
              aria-hidden="true"
            ></i>
          </div>-->
          <div class="row">
            <div class="col-md-3">
              <mat-form-field class="example-full-width">
                <mat-label>Total Weight</mat-label>

                <input
                  type="number"
                  min="0.00"
                  step="1"
                  id="totalWeight"
                  name="totalWeightForm"
                  [(ngModel)]="totalWeight"
                  matInput
                  placeholder="Total Weight"
                  required
                  (change)="sumarPeso()"
                />

                <span matSuffix>lbs</span>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field class="example-full-width">
                <mat-label>NET Weight</mat-label>

                <input
                  matInput
                  type="number"
                  min="0.01"
                  step="0.01"
                  placeholder="NET Weight"
                  name="totalNetWeightForm"
                  [(ngModel)]="totalNetWeight"
                  disabled
                  matNativeControl
                />
                <span matSuffix>lbs</span>
              </mat-form-field>
            </div>
            <div *ngIf="ispending == 0" class="col-md-3 mt-n4">
              <label>
                <i
                  *ngIf="loadingLocations"
                  class="fa fa-circle-o-notch fa-spin fa-fw"
                ></i
              ></label>
              <app-filter-object
                *ngIf="!loadingLocations"
                [options]="locationsList"
                placeholder="Location"
                [value]="location_id"
                (selectChange)="location_id = $event.id"
                (valueChange)="onValueChange($event)"
              ></app-filter-object>
            </div>
            <div class="col-md-3">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>Type Of Equipment</mat-label>

                <mat-select
                  name="tyoe"
                  [(ngModel)]="typeofe"
                  [disabled]="locktypeofequipment"
                >
                  <mat-option value="" disabled>Please select an option</mat-option>
                  <mat-option *ngFor="let item of typesofequipment" [value]="item">
                    {{ item }}
                  </mat-option>
                </mat-select>

                <!-- Candado dentro del form-field -->
                <button
                  mat-icon-button
                  matSuffix
                  class="lock-icon-btn"
                  tabindex="-1"
                  (click)="locktypeofequipment = !locktypeofequipment"
                  [attr.aria-label]="locktypeofequipment ? 'Locked' : 'Unlocked'"
                >
                  <mat-icon class="lock-icon">
                    {{ locktypeofequipment ? 'lock' : 'lock_open' }}
                  </mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>     
          <div class="row">
            <div class="col-md-6">
              <mat-form-field appearance="fill" class="mr-2 mt-n4" *ngIf="!itemShow">
                <mat-label>Notes</mat-label>
                <input
                  type="text"
                  value=""
                  matInput
                  placeholder="Notes:"
                  [(ngModel)]="notesContainer"
                />
              </mat-form-field>
            </div>
            <div class="col-md-3">
              
            </div>
            <div
              class="d-flex justify-content-end col-md-3 mt-n4"
              *ngIf="!itemShow && recived != '1'"
            >
              <button
                [disabled]="
                  !totalNetWeight ||
                  !item ||
                  !damages ||
                  location_id === null ||
                  totalNetWeight <= 0 ||
                  guardandoWeigth
                "
                (click)="saveWeights()"
                class="btn btn-primary"
                style="height: 50px; width: 170px;"
              >
                <i
                  *ngIf="guardandoWeigth"
                  class="fa fa-circle-o-notch fa-spin fa-fw"
                ></i>
                Add Container
              </button>
            </div>
          </div>   
          <!--<div class="d-flex mt-2">
            <mat-form-field appearance="fill" class="mr-2">
              <mat-label>Damages &nbsp; &nbsp; </mat-label>
              <select
                name="damagesForm"
                [(ngModel)]="damages"
                required
                matNativeControl
              >
                <option value="" disabled>Please select an option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </mat-form-field>
            <i
              class="fa {{ lockdamage ? 'fa-lock' : 'fa-unlock' }}"
              (click)="lockdamage = !lockdamage"
              style="cursor: pointer"
              aria-hidden="true"
            ></i>
          </div>-->
          <!-- <div class="form-group">
              <label for="damages">Damages &nbsp; &nbsp; <i class="fa {{lockdamage ? 'fa-lock' : 'fa-unlock'}}" (click)="lockdamage = !lockdamage" style="cursor: pointer;" aria-hidden="true"></i></label>
              <select
                name="damagesForm"
                [(ngModel)]="damages"
                class="form-control"
              >
                <option value="" disabled>Please select an option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div> -->
        </div>
        <div class="grid-container" *ngIf="recived != '1' || itemShow">
          
          <div *ngIf="ispending != 0">
            <div style="font-weight: 900" class="alert alert-danger">
              This container can't be moved or marked as processed because this
              container it's inside a ticket.
            </div>
          </div>
          <div>
            <!--<div style="position: relative" class="d-flex mt-2">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>Type Of Equipment &nbsp; &nbsp; </mat-label>
                <select name="tyoe" [(ngModel)]="typeofe" matNativeControl>
                  <option value="" disabled>Please select an option</option>
                  <option *ngFor="let item of typesofequipment" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </mat-form-field>
              <i
                class="fa {{ locktypeofequipment ? 'fa-lock' : 'fa-unlock' }}"
                (click)="locktypeofequipment = !locktypeofequipment"
                style="cursor: pointer; position: absolute; right: 0"
                aria-hidden="true"
              ></i>
            </div>-->

            <!-- <div class="form-group">
                <label for="tyoe"></label>
                <select
                  style="margin-top: 15px"
                  name="tyoe"
                  [(ngModel)]="typeofe"
                  class="form-control"
                >
                  <option value="" disabled>Please select an option</option>
                  <option *ngFor="let item of typesofequipment" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div> -->
          </div>
          <!--<div>
            <div style="position: relative" class="d-flex mt-2">
              <mat-form-field appearance="fill" class="mr-2">
                <mat-label>Stage</mat-label>

                <mat-select
                  name="is_piForm"
                  matNativeControl
                  [(ngModel)]="itemIsPi"
                  placeholder="Stage"
                  [disabled]="lockStage"
                >
                  <mat-option
                    *ngFor="let stage of stages"
                    [value]="stage.value"
                  >
                    {{ stage.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <i
                class="fa {{ lockStage ? 'fa-lock' : 'fa-unlock' }}"
                (click)="lockStage = !lockStage"
                style="cursor: pointer; position: absolute; right: 0"
                aria-hidden="true"
              ></i>
            </div>
          </div>-->
        </div>

        <div *ngIf="recived == '1'" class="">
          <div class="" style="text-align: right">
            <button class="btn btn-sm btn-danger" (click)="desbloquear()">
              unlock
            </button>
          </div>
        </div>
        <div *ngIf="itemShow">
          <!--<div class="col-12">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Notes:</label>
                                    <div class="form-group">
                                        <textarea name="notes" #notes="ngModel" [(ngModel)]="comments"
                                            class="form-control" rows="3"></textarea>
                                    </div>
                                </div>
                            </div>-->
          <div class="row">
            <div class="col-12">
              <h3>Notes</h3>
            </div>
          </div>
          <div class="row">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="panel panel-primary">
                    <div class="panel-heading" id="accordion"></div>
                    <div class="">
                      <div class="panel-body">
                        <ul class="chat">
                          <li
                            *ngFor="let chat of chatsWeights"
                            [ngClass]="[
                              chat['rep']['id'] == identity.sub
                                ? 'right'
                                : 'left'
                            ]"
                            class="left clearfix"
                          >
                            <span
                              class="chat-img"
                              [ngClass]="[
                                chat['rep']['id'] == identity.sub
                                  ? 'pull-right'
                                  : 'pull-left'
                              ]"
                            >
                              <img
                                *ngIf="chat['rep']['id'] != identity.sub"
                                width="40px"
                                style="border-radius: 50px"
                                src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
                                  chat['rep']['name'][0]
                                }}{{ chat['rep']['surname'][0] }}"
                                alt="User Avatar"
                                class="img-circle"
                              />
                              <img
                                *ngIf="chat['rep']['id'] == identity.sub"
                                width="40px"
                                style="border-radius: 50px"
                                src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
                                  chat['rep']['name'][0]
                                }}{{ chat['rep']['surname'][0] }}"
                                alt="User Avatar"
                                class="img-circle"
                              />
                            </span>
                            <div class="chat-body clearfix">
                              <div class="header" style="margin-bottom: 5px">
                                <small
                                  style="margin-left: -60px; float: left"
                                  *ngIf="chat['rep']['id'] == identity.sub"
                                >
                                  <i
                                    style="font-size: 20px; cursor: pointer"
                                    class="material-icons"
                                    (click)="deleteChatWeights(chat['id'])"
                                  >
                                    delete
                                  </i>
                                </small>
                                <small
                                  style="font-size: 0.7rem"
                                  *ngIf="chat['rep']['id'] == identity.sub"
                                  class="text-muted"
                                >
                                  <i
                                    style="font-size: 13px; margin-right: 5px"
                                    class="material-icons"
                                    >access_time</i
                                  >
                                  {{
                                    chat["createdAt"]["timestamp"] * 1000
                                      | date : "short"
                                  }}
                                </small>
                                <strong
                                  [ngClass]="[
                                    chat['rep']['id'] == identity.sub
                                      ? 'pull-right'
                                      : ''
                                  ]"
                                  class="primary-font"
                                  >{{ chat["rep"]["name"] }}
                                  {{ chat["rep"]["surname"] }}</strong
                                >
                                <small
                                  style="font-size: 0.7rem"
                                  *ngIf="chat['rep']['id'] != identity.sub"
                                  class="pull-right text-muted"
                                >
                                  <i
                                    style="font-size: 13px; margin-right: 5px"
                                    class="material-icons"
                                    >access_time</i
                                  >
                                  {{
                                    chat["createdAt"]["timestamp"] * 1000
                                      | date : "short"
                                  }}</small
                                >
                              </div>
                              <p
                                [ngClass]="[
                                  chat['rep']['id'] == identity.sub
                                    ? 'text-right'
                                    : ''
                                ]"
                              >
                                {{ chat["message"] }}
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div style="margin-top: 20px" class="panel-footer">
                        <mat-progress-bar
                          style="width: 80%"
                          *ngIf="loading"
                          id="loadingbar"
                          mode="indeterminate"
                        ></mat-progress-bar>
                        <app-message-input
                          (sendMessage)="sendMessageWeights($event)"
                        ></app-message-input>
                        <!--<div class="input-group">
                              <textarea
                                id="btn-input"
                                name="newchatmsg"
                                [(ngModel)]="newchatmsg"
                                type="text"
                                class="form-control input-sm"
                                placeholder="Type your message here..."
                              >
                                                                ></textarea
                              >
                              <span class="input-group-btn">
                                <button
                                  (click)="sendChatWeights()"
                                  class="btn btn-warning btn-sm"
                                  id="btn-chat"
                                >
                                  Send
                                </button>
                              </span>
                            </div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="loadingEditWeight" style="text-align: center">
            <h2>
              <b
                ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                Loading...</b
              >
            </h2>
          </div>
          <button *ngIf="itemShow" class="btn btn-danger" (click)="closeItem()">
            <i class="fa fa-reply" aria-hidden="true"></i> Back
          </button>
          <button
            (click)="updatelocation()"
            class="btn btn-success"
            *ngIf="itemShow"
            [disabled] = "loadingEditWeight"
          >
            Save
          </button>
          <div
            style="display: none; padding: 10px"
            class="text-success"
            id="donelocation"
          >
            <span
              style="vertical-align: text-bottom"
              class="material-icons text-success"
            >
              done
            </span>
            Changes successfully saved
          </div>
          <div
            style="display: none; padding: 10px"
            id="errordonelocation"
            class="text-danger"
          >
            <span
              style="vertical-align: text-bottom"
              class="material-icons text-danger"
            >
              report_problem
            </span>
            Something went wrong
          </div>
        </div>
        <hr *ngIf="recived != '1' && !itemShow" style="border: 4px solid #9933ff; margin-top: -25px;" />
        <div class="row" *ngIf="!itemShow">
          <div class="col-md-12 mt-n3">
            <h3><strong>Items</strong></h3>
            <div style="display: flex; justify-content: space-between; gap: 10px; margin-top: 10px;">
              <div style="flex: 1; background-color: #e6c6f1; padding: 8px;">
                <h6 style="margin: 0; color: purple; font-weight: bold; text-transform: none !important">
                  Total Weight: {{ tlWG }}
                </h6>
              </div>
              <div style="flex: 1; background-color: #e6c6f1; padding: 8px;">
                <h6 style="margin: 0; color: purple; font-weight: bold; text-transform: none !important">
                  Total Containers: {{ tableContacts.rows.length }}
                </h6>
              </div>
            </div>
            <div *ngIf="buscando" style="text-align: center">
              <h2>
                <b
                  ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  Loading...</b
                >
              </h2>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex" style="gap: 10px; flex-wrap: wrap;">

                <!--Switche-->
                  <mat-slide-toggle
                    [(ngModel)]="hideprocessed"
                    (change)="changesidle()"
                  >
                    Hide processed containers
                  </mat-slide-toggle>
                  <mat-slide-toggle
                    [(ngModel)]="showall"
                    (change)="changesidle()"
                  >
                    Show all containers
                  </mat-slide-toggle>
                <!--<div class="form-check">
                  <label class="form-check-label">
                    <input
                      [checked]="hideprocessed"
                      name="shall"
                      [(ngModel)]="hideprocessed"
                      (change)="getItemsWeights()"
                      class="form-check-input"
                      type="checkbox"
                    />
                    Hide processed containers
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div class="form-check">
                  <label class="form-check-label">
                    <input
                      [checked]="showall"
                      name="hidep"
                      [(ngModel)]="showall"
                      (change)="getItemsWeights()"
                      class="form-check-input"
                      type="checkbox"
                    />
                    Show all containers
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>-->
              </div>
            </div>
            <!-- <app-weight-table

                  *ngIf="!buscando"
                  [dataTable]="tableContacts"
                  (out)="itemAction($event)"
                ></app-weight-table> -->
            <dinamic-table
              *ngIf="!buscando"
              [id]="'proccess_weight'"
              [dbname]="'proccessweighttable'"
              [data]="tableContacts"
              [frontpaginate]="false"
              [cleanbulk]="false"
              [columnfilters]="filterweight"
              (buscar)="getItemsWeights($event)"
              [perPage]="itemsPorPagina"
              [page]="paginaActual"
              [total_items_count]="totalItems"
              [total_pages]="totalPaginas"
              (action_button)="itemAction($event)"
              (newConfig)="updateConfigweight($event)"
              [config]="optionsweight"
              (rightClickAction)="handleRightClick($event)" 
            ></dinamic-table>
            <!-- <app-table *ngIf="!buscando" [dataTable]="tableContacts" (out)="itemAction($event)" [print]="true"></app-table> -->
          </div>
        </div>
        <div class="" *ngIf="recived != '1' || itemShow">
          <div *ngIf="!itemShow && recived != '1'">
            <button
              [disabled]="tableContacts.rows.length == 0"
              (click)="goToManifest()"
              class="btn btn-success btn-small"
            >
              <!--  || step != 'PICKEDUP' -->
              <i class="material-icons">done</i> Receive!
            </button>
          </div>
        </div>
      </div>
      <!-- --------------------------------------Seccion 9------------------------------------------ -->
      <div
        *ngIf="
          tab == 9 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div
          *ngIf="action != 'create' && !itemShow"
          style="width: 90%; padding: 20px; margin: 0 auto"
        >
          <app-multi-files
            [idfather]="item.id"
            [type]="'FILESPROCESSING'"
            [poNumber]="item.po.name"
            (total)="numFiles = $event"
          ></app-multi-files>
        </div>
      </div>
      <!-- --------------------------------------Seccion 10------------------------------------------ -->
      <div
        *ngIf="
          tab == 10 &&
          !newManifest &&
          !newManifest2 &&
          !splitManifest &&
          deletManiest_id == null &&
          !erasure &&
          !changeStatus
        "
      >
        <div style="margin-top: 20px" class="panel-footer grid-container-one">
          <mat-progress-bar
            style="width: 80%"
            *ngIf="loading"
            id="loadingbar"
            mode="indeterminate"
          ></mat-progress-bar>
          <app-comments
            [is_Chatlog]="false"
            [id_phather]="id"
            type_notification="CITA_COMMENT"
          ></app-comments>
          <!-- <app-message-input
              (sendMessage)="sendMessage($event)"
            ></app-message-input> -->
          <!--<div class="input-group">
                                        <textarea id="btn-input" name="newchatmsg"
                                            [(ngModel)]="newchatmsg" type="text"
                                            class="form-control input-sm"
                                            placeholder="Type your message here...">
                                        </textarea>
                                        <span class="input-group-btn">
                                            <button (click)="sendChat()" class="btn btn-warning btn-sm"
                                                id="btn-chat">
                                                Send</button>
                                        </span>
                                    </div>-->
        </div>
        <div class="panel panel-primary">
          <div class="panel-heading" id="accordion"></div>
          <div class="panel-body" *ngIf="chats.lenght > 0">
            <ul class="chat">
              <li
                *ngFor="let chat of chats"
                [ngClass]="[
                  chat['rep']['id'] == identity.sub ? 'right' : 'left'
                ]"
                class="left clearfix"
              >
                <span
                  class="chat-img"
                  [ngClass]="[
                    chat['rep']['id'] == identity.sub
                      ? 'pull-right'
                      : 'pull-left'
                  ]"
                >
                  <img
                    *ngIf="chat['rep']['id'] != identity.sub"
                    width="40px"
                    style="border-radius: 50px"
                    src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
                      chat['rep']['name'][0]
                    }}{{ chat['rep']['surname'][0] }}"
                    alt="User Avatar"
                    class="img-circle"
                  />
                  <img
                    *ngIf="chat['rep']['id'] == identity.sub"
                    width="40px"
                    style="border-radius: 50px"
                    src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
                      chat['rep']['name'][0]
                    }}{{ chat['rep']['surname'][0] }}"
                    alt="User Avatar"
                    class="img-circle"
                  />
                </span>
                <div class="chat-body clearfix">
                  <div class="header" style="margin-bottom: 5px">
                    <small
                      style="margin-left: -60px; float: left"
                      *ngIf="chat['rep']['id'] == identity.sub"
                    >
                      <i
                        style="font-size: 20px; cursor: pointer"
                        class="material-icons"
                        (click)="deleteChat(chat['id'])"
                      >
                        delete
                      </i>
                    </small>
                    <small
                      style="font-size: 0.7rem"
                      *ngIf="chat['rep']['id'] == identity.sub"
                      class="text-muted"
                    >
                      <i
                        style="font-size: 13px; margin-right: 5px"
                        class="material-icons"
                        >access_time</i
                      >
                      {{
                        chat["createdAt"]["timestamp"] * 1000 | date : "short"
                      }}
                    </small>
                    <strong
                      [ngClass]="[
                        chat['rep']['id'] == identity.sub ? 'pull-right' : ''
                      ]"
                      class="primary-font"
                      >{{ chat["rep"]["name"] }}
                      {{ chat["rep"]["surname"] }}</strong
                    >
                    <small
                      style="font-size: 0.7rem"
                      *ngIf="chat['rep']['id'] != identity.sub"
                      class="pull-right text-muted"
                    >
                      <i
                        style="font-size: 13px; margin-right: 5px"
                        class="material-icons"
                        >access_time</i
                      >
                      {{
                        chat["createdAt"]["timestamp"] * 1000 | date : "short"
                      }}</small
                    >
                  </div>
                  <p
                    style="white-space: pre-wrap"
                    [ngClass]="[
                      chat['rep']['id'] == identity.sub ? 'text-right' : ''
                    ]"
                  >
                    {{ chat["message"] }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div *ngIf="action == 'delete'">
        <h6>
          <b
            ><i
              class="fa fa-exclamation-triangle"
              style="color: 'red'"
              aria-hidden="true"
            ></i>
            Are you sure you want to delete this processing instruction?
          </b>
        </h6>
      </div>
      <!--   </form> -->
      <div class="d-flex justify-content-end">
        <a
          target="_blank"
          routerLink="/purchase-order/{{ item.po.id }}"
          routerLinkActive="active"
          target="_blank"
        >
          <button class="btn btn-success btn-small noticket mr-2">
            View PO
          </button>
        </a>
        <button
          *ngIf="
            (guard.permissions('edit-pi') &&
              action == 'read' &&
              !editar &&
              hasButton) ||
            (action == 'read' &&
              identity.role == 'ADMINISTRATOR' &&
              !editar &&
              hasButton &&
              this.newManifest2 == false)
          "
          class="btn btn-primary btn-small noticket"
          (click)="editar = true"
        >
          <i class="material-icons mr-2">edit</i>
          Edit
        </button>
        <button
          *ngIf="
            (guard.permissions('edit-pi') && action == 'read' && editar) ||
            (action == 'read' && editar && identity.role == 'ADMINISTRATOR')
          "
          class="btn btn-primary btn-small"
          (click)="guardarEditar(f)"
        >
          Save
        </button>
        <button
          type="button"
          *ngIf="
            (guard.permissions('edit-pi') && action == 'read' && editar) ||
            (action == 'read' && editar && identity.role == 'ADMINISTRATOR')
          "
          class="btn btn-danger btn-md noticket"
          (click)="editar = false"
        >
          Cancel
        </button>
        <button
          *ngIf="tab != 1 && action != 'read'"
          class="btn btn-primary btn-md"
          (click)="changeTab(tab - 1)"
        >
          <i class="material-icons">navigate_before</i> previous
        </button>
        <button
          *ngIf="action != 'read' && action != 'delete' && !createPO"
          type="button"
          class="btn btn-primary btn-md"
          (click)="save(f)"
          [disabled]="!f.valid && tab != 6"
        >
          <span *ngIf="action == 'create' && tab != 4"
            >Next <i class="material-icons">navigate_next</i></span
          >
          <span *ngIf="action == 'create' && tab == 4">Save</span>
        </button>
        <button
          *ngIf="createPO"
          type="button"
          class="btn btn-primary btn-md"
          (click)="creandoPO(f)"
          [disabled]="clientSelected === '' || creatingpo"
        >
          <i *ngIf="creatingpo" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          <span>Next <i class="material-icons">navigate_next</i></span>
        </button>
        <button
          *ngIf="action == 'delete'"
          type="button"
          class="btn btn-primary btn-md"
          (click)="deleteItem()"
        >
          <span>Continue</span>
        </button>
      </div>
    </div>
    <div class="modal-body" *ngIf="!reports">
      <div class="d-flex justify-content-between">
        <div *ngIf="action == 'read'" class="w-100">
          <!-- <button
            class="btn btn-info btn-md"
            (click)="markProcessed()"
            *ngIf="
              guard.permissions('mark-processed') &&
              itemsOnDepartament.numReceived <= 0 &&
              itemsOnDepartament.num_received_second <= 0 &&
              itemsOnDepartament.numInmanifest <= 0 &&
              itemsOnDepartament.num_inmanifest_second <= 0 &&
              itemsOnDepartament.numIntesting <= 0 &&
              itemsOnDepartament.num_intesting_second <= 0 &&
              itemsOnDepartament.numInsales <= 0 &&
              itemsOnDepartament.num_insales_second <= 0 &&
              (itemsOnDepartament.num_processed > 0 ||
                itemsOnDepartament.num_processed_second > 0)
            "
          >
            <span style="text-align: center">Mark PO<br />as processed</span>
          </button>-->
          <div class="d-flex justify-content-between"></div>
        </div>
      </div>
      <!-- TABS ASSIGN -->
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <button
            class="btn btn-info btn-md mr-2"
            (click)="asignar = 'setsales'"
            *ngIf="guard.permissions('assignsalerep') && sales == ''"
          >
            <span>Assign Sales Rep</span>
          </button>
          <button
            class="btn btn-outline-info btn-md mr-2"
            (click)="unassign('unassignsales')"
            *ngIf="guard.permissions('assignsalerep') && sales != ''"
          >
            <span>Unassign Sales Rep</span>
          </button>

          <button
            class="btn btn-info btn-md mr-2"
            (click)="asignar = 'setmanifest'"
            *ngIf="guard.permissions('asaignmanifestrep') && manifest == ''"
          >
            <span>Assign Manifest Rep</span>
          </button>
          <button
            class="btn btn-outline-info btn-md mr-2"
            (click)="unassign('unassignmanifest')"
            *ngIf="guard.permissions('asaignmanifestrep') && manifest != ''"
          >
            <span>UnAssign Manifest Rep</span>
          </button>

          <button
            class="btn btn-info btn-md mr-2"
            (click)="asignar = 'settech'"
            *ngIf="guard.permissions('assigntechrep') && tech == ''"
          >
            <span>Assign Tech</span>
          </button>
          <button
            class="btn btn-outline-info btn-md mr-2"
            (click)="unassign('unassigntech')"
            *ngIf="guard.permissions('assigntechrep') && tech != ''"
          >
            <span style="text-align: center">UnAssign Tech</span>
          </button>
          <div class="d-flex">
            <button
              class="btn btn-warning btn-md mr-2"
              (click)="cambiandoStatus()"
              *ngIf="guard.permissions('change-status-pi')"
            >
              <span>Change Status</span>
            </button>
            <button
              [ngClass]="[
                reportCompleted === 1
                  ? 'btn btn-success btn-md'
                  : 'btn btn-info btn-md'
              ]"
              class="btn btn-success btn-md mr-2"
              (click)="viewReport()"
              *ngIf="action == 'read' && reportID !== null"
            >
              View PDR
            </button>
            <button
              class="btn btn-info btn-md mr-2"
              (click)="createReport()"
              *ngIf="action == 'read' && reportID === null"
            >
              + Create PDR
            </button>
            <a
              class="btn btn-primary btn-md d-flex align-items-center"
              *ngIf="action == 'read' && folderId != ''"
              target="_blank"
              routerLink="/tables/listfiles/{{ folderId }}"
            >
              <span class="mr-2">Go to CV</span>
              <i class="fa fa-folder-open-o" aria-hidden="true"></i
            ></a>
          </div>
        </div>

        <div class="d-flex">
          <button
            class="btn btn-warning btn-md mr-2"
            (click)="markasPaid()"
            *ngIf="
              (guard.permissions('mark-processed') && item.isPaid == 0) ||
              item.isPaid == null
            "
          >
            <span *ngIf="this.item.netTerms != 22" style="text-align: center"
              >Mark PO as paid</span
            >
            <span *ngIf="this.item.netTerms == 22" style="text-align: center"
              >Payment Received</span
            >
          </button>
          <button
            class="btn btn-warning btn-md mr-2"
            (click)="markcompleted()"
            [disabled]="!firstProcesados()"
            *ngIf="
              guard.permissions('mark-completed') &&
              item.manifestStatus != 'Completed'
            "
          >
            <span>Mark manifest as completed</span>
          </button>
          <button
            class="btn btn-warning btn-md mr-2"
            (click)="markuncompleted()"
            *ngIf="
              guard.permissions('undonemanifest') &&
              item.manifestStatus == 'Completed'
            "
          >
            <span>Mark manifest as NOT completed</span>
          </button>
          <!-- <button
            class="btn btn-warning btn-md"
            (click)="testingComplete()"
            [disabled]="!firstProcesados()"
            *ngIf="
              guard.permissions('testing-completed') &&
              testingStatus != 'Completed'
            "
          >
            <span> Mark testing as completed</span>
          </button> -->

          <button
            class="btn btn-warning btn-md mr-2"
            *ngIf="guard.permissions('testing-completed')"
            style="padding: 20px"
            mat-button
            [matMenuTriggerFor]="menu"
          >
            <span>Change Testing Status</span>
          </button>
          <mat-menu #menu="matMenu">
            <button
              [disabled]="testingStatusForm == 'Pending'"
              (click)="changetestingstatus(item, 'Pending')"
              class="btn btn-outline-danger"
              mat-menu-item
            >
              Pending
            </button>
            <button
              [disabled]="testingStatusForm == 'In Progress'"
              (click)="changetestingstatus(item, 'In Progress')"
              class="btn btn-outline-warning"
              mat-menu-item
            >
              In Progress
            </button>
            <button
              [disabled]="testingStatusForm == 'Completed'"
              (click)="changetestingstatus(item, 'Completed')"
              class="btn btn-outline-success"
              mat-menu-item
            >
              Completed
            </button>
          </mat-menu>
        </div>
      </div>
      <div *ngIf="asignar === 'setmanifest'">
        <mat-form-field appearance="fill" class="mr-4">
          <mat-label>Assign manifest</mat-label>
          <select
            name="asignacion"
            [(ngModel)]="set_id"
            required
            matNativeControl
          >
            <option value="" disabled>Select Rep</option>
            <option *ngFor="let rep of manifestList" [value]="rep.id">
              {{ rep.name }} {{ rep.surname }}
            </option>
          </select>
        </mat-form-field>
      </div>
      <div *ngIf="asignar === 'setsales'">
        <mat-form-field appearance="fill" class="mr-4">
          <mat-label>Assign sales</mat-label>
          <select
            name="asignacion"
            [(ngModel)]="set_id"
            required
            matNativeControl
          >
            <option value="" disabled>Select Rep</option>
            <option *ngFor="let rep of salesList" [value]="rep.id">
              {{ rep.name }} {{ rep.surname }}
            </option>
          </select>
        </mat-form-field>
      </div>
      <div *ngIf="asignar === 'settech'">
        <mat-form-field appearance="fill" class="mr-4">
          <mat-label>Assign tech</mat-label>
          <select
            name="asignacion"
            [(ngModel)]="set_id"
            required
            matNativeControl
          >
            <option value="" disabled>Select Rep</option>
            <option *ngFor="let rep of techList" [value]="rep.id">
              {{ rep.name }} {{ rep.surname }}
            </option>
          </select>
        </mat-form-field>
      </div>
      <div
        *ngIf="
          asignar == 'setsales' ||
          asignar == 'settech' ||
          asignar == 'setmanifest'
        "
      >
        <div class="" style="text-align: right">
          <button class="btn btn-danger btn-sm" (click)="cancelAssign()">
            <i class="fa fa-reply" aria-hidden="true"></i> BACK
          </button>
          &nbsp;
          <button
            class="btn btn-success btn-sm"
            (click)="assign()"
            [disabled]="
              set_id === '' &&
              (asignar === 'settech' ||
                asignar === 'setsales' ||
                asignar === 'setmanifest')
            "
          >
            ACCEPT
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" data-backdrop="static" id="unassigned" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <b> Are you sure you want to unassigned?</b>
        </h5>
        <!-- <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger mr-4" (click)="cancelAssign()">
          <i class="fa fa-reply" aria-hidden="true"></i> BACK
        </button>
        <button
          class="btn btn-success"
          (click)="assign()"
          [disabled]="
            set_id === '' &&
            (asignar === 'settech' ||
              asignar === 'setsales' ||
              asignar === 'setmanifest')
          "
        >
          ACCEPT
        </button>
      </div>
    </div>
  </div>
</div>
